import { __assign } from "tslib";
import { isa as __isa } from "@aws-sdk/smithy-client";
export var __EndpointTypesElement;
(function (__EndpointTypesElement) {
    __EndpointTypesElement["ADM"] = "ADM";
    __EndpointTypesElement["APNS"] = "APNS";
    __EndpointTypesElement["APNS_SANDBOX"] = "APNS_SANDBOX";
    __EndpointTypesElement["APNS_VOIP"] = "APNS_VOIP";
    __EndpointTypesElement["APNS_VOIP_SANDBOX"] = "APNS_VOIP_SANDBOX";
    __EndpointTypesElement["BAIDU"] = "BAIDU";
    __EndpointTypesElement["CUSTOM"] = "CUSTOM";
    __EndpointTypesElement["EMAIL"] = "EMAIL";
    __EndpointTypesElement["GCM"] = "GCM";
    __EndpointTypesElement["PUSH"] = "PUSH";
    __EndpointTypesElement["SMS"] = "SMS";
    __EndpointTypesElement["VOICE"] = "VOICE";
})(__EndpointTypesElement || (__EndpointTypesElement = {}));
export var Action;
(function (Action) {
    Action["DEEP_LINK"] = "DEEP_LINK";
    Action["OPEN_APP"] = "OPEN_APP";
    Action["URL"] = "URL";
})(Action || (Action = {}));
export var ActivitiesResponse;
(function (ActivitiesResponse) {
    ActivitiesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ActivitiesResponse.isa = function (o) { return __isa(o, "ActivitiesResponse"); };
})(ActivitiesResponse || (ActivitiesResponse = {}));
export var Activity;
(function (Activity) {
    Activity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Activity.isa = function (o) { return __isa(o, "Activity"); };
})(Activity || (Activity = {}));
export var ActivityResponse;
(function (ActivityResponse) {
    ActivityResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ActivityResponse.isa = function (o) { return __isa(o, "ActivityResponse"); };
})(ActivityResponse || (ActivityResponse = {}));
export var AddressConfiguration;
(function (AddressConfiguration) {
    AddressConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AddressConfiguration.isa = function (o) { return __isa(o, "AddressConfiguration"); };
})(AddressConfiguration || (AddressConfiguration = {}));
export var ADMChannelRequest;
(function (ADMChannelRequest) {
    ADMChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ADMChannelRequest.isa = function (o) { return __isa(o, "ADMChannelRequest"); };
})(ADMChannelRequest || (ADMChannelRequest = {}));
export var ADMChannelResponse;
(function (ADMChannelResponse) {
    ADMChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ADMChannelResponse.isa = function (o) { return __isa(o, "ADMChannelResponse"); };
})(ADMChannelResponse || (ADMChannelResponse = {}));
export var ADMMessage;
(function (ADMMessage) {
    ADMMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ADMMessage.isa = function (o) { return __isa(o, "ADMMessage"); };
})(ADMMessage || (ADMMessage = {}));
export var AndroidPushNotificationTemplate;
(function (AndroidPushNotificationTemplate) {
    AndroidPushNotificationTemplate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AndroidPushNotificationTemplate.isa = function (o) { return __isa(o, "AndroidPushNotificationTemplate"); };
})(AndroidPushNotificationTemplate || (AndroidPushNotificationTemplate = {}));
export var APNSChannelRequest;
(function (APNSChannelRequest) {
    APNSChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    APNSChannelRequest.isa = function (o) { return __isa(o, "APNSChannelRequest"); };
})(APNSChannelRequest || (APNSChannelRequest = {}));
export var APNSChannelResponse;
(function (APNSChannelResponse) {
    APNSChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    APNSChannelResponse.isa = function (o) { return __isa(o, "APNSChannelResponse"); };
})(APNSChannelResponse || (APNSChannelResponse = {}));
export var APNSMessage;
(function (APNSMessage) {
    APNSMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    APNSMessage.isa = function (o) { return __isa(o, "APNSMessage"); };
})(APNSMessage || (APNSMessage = {}));
export var APNSPushNotificationTemplate;
(function (APNSPushNotificationTemplate) {
    APNSPushNotificationTemplate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    APNSPushNotificationTemplate.isa = function (o) { return __isa(o, "APNSPushNotificationTemplate"); };
})(APNSPushNotificationTemplate || (APNSPushNotificationTemplate = {}));
export var APNSSandboxChannelRequest;
(function (APNSSandboxChannelRequest) {
    APNSSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    APNSSandboxChannelRequest.isa = function (o) { return __isa(o, "APNSSandboxChannelRequest"); };
})(APNSSandboxChannelRequest || (APNSSandboxChannelRequest = {}));
export var APNSSandboxChannelResponse;
(function (APNSSandboxChannelResponse) {
    APNSSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    APNSSandboxChannelResponse.isa = function (o) { return __isa(o, "APNSSandboxChannelResponse"); };
})(APNSSandboxChannelResponse || (APNSSandboxChannelResponse = {}));
export var APNSVoipChannelRequest;
(function (APNSVoipChannelRequest) {
    APNSVoipChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    APNSVoipChannelRequest.isa = function (o) { return __isa(o, "APNSVoipChannelRequest"); };
})(APNSVoipChannelRequest || (APNSVoipChannelRequest = {}));
export var APNSVoipChannelResponse;
(function (APNSVoipChannelResponse) {
    APNSVoipChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    APNSVoipChannelResponse.isa = function (o) { return __isa(o, "APNSVoipChannelResponse"); };
})(APNSVoipChannelResponse || (APNSVoipChannelResponse = {}));
export var APNSVoipSandboxChannelRequest;
(function (APNSVoipSandboxChannelRequest) {
    APNSVoipSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    APNSVoipSandboxChannelRequest.isa = function (o) { return __isa(o, "APNSVoipSandboxChannelRequest"); };
})(APNSVoipSandboxChannelRequest || (APNSVoipSandboxChannelRequest = {}));
export var APNSVoipSandboxChannelResponse;
(function (APNSVoipSandboxChannelResponse) {
    APNSVoipSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    APNSVoipSandboxChannelResponse.isa = function (o) { return __isa(o, "APNSVoipSandboxChannelResponse"); };
})(APNSVoipSandboxChannelResponse || (APNSVoipSandboxChannelResponse = {}));
export var ApplicationDateRangeKpiResponse;
(function (ApplicationDateRangeKpiResponse) {
    ApplicationDateRangeKpiResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ApplicationDateRangeKpiResponse.isa = function (o) { return __isa(o, "ApplicationDateRangeKpiResponse"); };
})(ApplicationDateRangeKpiResponse || (ApplicationDateRangeKpiResponse = {}));
export var ApplicationResponse;
(function (ApplicationResponse) {
    ApplicationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ApplicationResponse.isa = function (o) { return __isa(o, "ApplicationResponse"); };
})(ApplicationResponse || (ApplicationResponse = {}));
export var ApplicationSettingsResource;
(function (ApplicationSettingsResource) {
    ApplicationSettingsResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ApplicationSettingsResource.isa = function (o) { return __isa(o, "ApplicationSettingsResource"); };
})(ApplicationSettingsResource || (ApplicationSettingsResource = {}));
export var ApplicationsResponse;
(function (ApplicationsResponse) {
    ApplicationsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ApplicationsResponse.isa = function (o) { return __isa(o, "ApplicationsResponse"); };
})(ApplicationsResponse || (ApplicationsResponse = {}));
export var AttributeDimension;
(function (AttributeDimension) {
    AttributeDimension.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AttributeDimension.isa = function (o) { return __isa(o, "AttributeDimension"); };
})(AttributeDimension || (AttributeDimension = {}));
export var AttributesResource;
(function (AttributesResource) {
    AttributesResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    AttributesResource.isa = function (o) { return __isa(o, "AttributesResource"); };
})(AttributesResource || (AttributesResource = {}));
export var AttributeType;
(function (AttributeType) {
    AttributeType["EXCLUSIVE"] = "EXCLUSIVE";
    AttributeType["INCLUSIVE"] = "INCLUSIVE";
})(AttributeType || (AttributeType = {}));
export var BadRequestException;
(function (BadRequestException) {
    BadRequestException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    BadRequestException.isa = function (o) { return __isa(o, "BadRequestException"); };
})(BadRequestException || (BadRequestException = {}));
export var BaiduChannelRequest;
(function (BaiduChannelRequest) {
    BaiduChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    BaiduChannelRequest.isa = function (o) { return __isa(o, "BaiduChannelRequest"); };
})(BaiduChannelRequest || (BaiduChannelRequest = {}));
export var BaiduChannelResponse;
(function (BaiduChannelResponse) {
    BaiduChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    BaiduChannelResponse.isa = function (o) { return __isa(o, "BaiduChannelResponse"); };
})(BaiduChannelResponse || (BaiduChannelResponse = {}));
export var BaiduMessage;
(function (BaiduMessage) {
    BaiduMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    BaiduMessage.isa = function (o) { return __isa(o, "BaiduMessage"); };
})(BaiduMessage || (BaiduMessage = {}));
export var BaseKpiResult;
(function (BaseKpiResult) {
    BaseKpiResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    BaseKpiResult.isa = function (o) { return __isa(o, "BaseKpiResult"); };
})(BaseKpiResult || (BaseKpiResult = {}));
export var CampaignCustomMessage;
(function (CampaignCustomMessage) {
    CampaignCustomMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CampaignCustomMessage.isa = function (o) { return __isa(o, "CampaignCustomMessage"); };
})(CampaignCustomMessage || (CampaignCustomMessage = {}));
export var CampaignDateRangeKpiResponse;
(function (CampaignDateRangeKpiResponse) {
    CampaignDateRangeKpiResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CampaignDateRangeKpiResponse.isa = function (o) { return __isa(o, "CampaignDateRangeKpiResponse"); };
})(CampaignDateRangeKpiResponse || (CampaignDateRangeKpiResponse = {}));
export var CampaignEmailMessage;
(function (CampaignEmailMessage) {
    CampaignEmailMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CampaignEmailMessage.isa = function (o) { return __isa(o, "CampaignEmailMessage"); };
})(CampaignEmailMessage || (CampaignEmailMessage = {}));
export var CampaignEventFilter;
(function (CampaignEventFilter) {
    CampaignEventFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CampaignEventFilter.isa = function (o) { return __isa(o, "CampaignEventFilter"); };
})(CampaignEventFilter || (CampaignEventFilter = {}));
export var CampaignHook;
(function (CampaignHook) {
    CampaignHook.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CampaignHook.isa = function (o) { return __isa(o, "CampaignHook"); };
})(CampaignHook || (CampaignHook = {}));
export var CampaignLimits;
(function (CampaignLimits) {
    CampaignLimits.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CampaignLimits.isa = function (o) { return __isa(o, "CampaignLimits"); };
})(CampaignLimits || (CampaignLimits = {}));
export var CampaignResponse;
(function (CampaignResponse) {
    CampaignResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CampaignResponse.isa = function (o) { return __isa(o, "CampaignResponse"); };
})(CampaignResponse || (CampaignResponse = {}));
export var CampaignSmsMessage;
(function (CampaignSmsMessage) {
    CampaignSmsMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CampaignSmsMessage.isa = function (o) { return __isa(o, "CampaignSmsMessage"); };
})(CampaignSmsMessage || (CampaignSmsMessage = {}));
export var CampaignsResponse;
(function (CampaignsResponse) {
    CampaignsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CampaignsResponse.isa = function (o) { return __isa(o, "CampaignsResponse"); };
})(CampaignsResponse || (CampaignsResponse = {}));
export var CampaignState;
(function (CampaignState) {
    CampaignState.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CampaignState.isa = function (o) { return __isa(o, "CampaignState"); };
})(CampaignState || (CampaignState = {}));
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["COMPLETED"] = "COMPLETED";
    CampaignStatus["DELETED"] = "DELETED";
    CampaignStatus["EXECUTING"] = "EXECUTING";
    CampaignStatus["PAUSED"] = "PAUSED";
    CampaignStatus["PENDING_NEXT_RUN"] = "PENDING_NEXT_RUN";
    CampaignStatus["SCHEDULED"] = "SCHEDULED";
})(CampaignStatus || (CampaignStatus = {}));
export var ChannelResponse;
(function (ChannelResponse) {
    ChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ChannelResponse.isa = function (o) { return __isa(o, "ChannelResponse"); };
})(ChannelResponse || (ChannelResponse = {}));
export var ChannelsResponse;
(function (ChannelsResponse) {
    ChannelsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ChannelsResponse.isa = function (o) { return __isa(o, "ChannelsResponse"); };
})(ChannelsResponse || (ChannelsResponse = {}));
export var ChannelType;
(function (ChannelType) {
    ChannelType["ADM"] = "ADM";
    ChannelType["APNS"] = "APNS";
    ChannelType["APNS_SANDBOX"] = "APNS_SANDBOX";
    ChannelType["APNS_VOIP"] = "APNS_VOIP";
    ChannelType["APNS_VOIP_SANDBOX"] = "APNS_VOIP_SANDBOX";
    ChannelType["BAIDU"] = "BAIDU";
    ChannelType["CUSTOM"] = "CUSTOM";
    ChannelType["EMAIL"] = "EMAIL";
    ChannelType["GCM"] = "GCM";
    ChannelType["PUSH"] = "PUSH";
    ChannelType["SMS"] = "SMS";
    ChannelType["VOICE"] = "VOICE";
})(ChannelType || (ChannelType = {}));
export var Condition;
(function (Condition) {
    Condition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Condition.isa = function (o) { return __isa(o, "Condition"); };
})(Condition || (Condition = {}));
export var ConditionalSplitActivity;
(function (ConditionalSplitActivity) {
    ConditionalSplitActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ConditionalSplitActivity.isa = function (o) { return __isa(o, "ConditionalSplitActivity"); };
})(ConditionalSplitActivity || (ConditionalSplitActivity = {}));
export var CreateApplicationRequest;
(function (CreateApplicationRequest) {
    CreateApplicationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateApplicationRequest.isa = function (o) { return __isa(o, "CreateApplicationRequest"); };
})(CreateApplicationRequest || (CreateApplicationRequest = {}));
export var CreateAppRequest;
(function (CreateAppRequest) {
    CreateAppRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateAppRequest.isa = function (o) { return __isa(o, "CreateAppRequest"); };
})(CreateAppRequest || (CreateAppRequest = {}));
export var CreateAppResponse;
(function (CreateAppResponse) {
    CreateAppResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateAppResponse.isa = function (o) { return __isa(o, "CreateAppResponse"); };
})(CreateAppResponse || (CreateAppResponse = {}));
export var CreateCampaignRequest;
(function (CreateCampaignRequest) {
    CreateCampaignRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateCampaignRequest.isa = function (o) { return __isa(o, "CreateCampaignRequest"); };
})(CreateCampaignRequest || (CreateCampaignRequest = {}));
export var CreateCampaignResponse;
(function (CreateCampaignResponse) {
    CreateCampaignResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateCampaignResponse.isa = function (o) { return __isa(o, "CreateCampaignResponse"); };
})(CreateCampaignResponse || (CreateCampaignResponse = {}));
export var CreateEmailTemplateRequest;
(function (CreateEmailTemplateRequest) {
    CreateEmailTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateEmailTemplateRequest.isa = function (o) { return __isa(o, "CreateEmailTemplateRequest"); };
})(CreateEmailTemplateRequest || (CreateEmailTemplateRequest = {}));
export var CreateEmailTemplateResponse;
(function (CreateEmailTemplateResponse) {
    CreateEmailTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateEmailTemplateResponse.isa = function (o) { return __isa(o, "CreateEmailTemplateResponse"); };
})(CreateEmailTemplateResponse || (CreateEmailTemplateResponse = {}));
export var CreateExportJobRequest;
(function (CreateExportJobRequest) {
    CreateExportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateExportJobRequest.isa = function (o) { return __isa(o, "CreateExportJobRequest"); };
})(CreateExportJobRequest || (CreateExportJobRequest = {}));
export var CreateExportJobResponse;
(function (CreateExportJobResponse) {
    CreateExportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateExportJobResponse.isa = function (o) { return __isa(o, "CreateExportJobResponse"); };
})(CreateExportJobResponse || (CreateExportJobResponse = {}));
export var CreateImportJobRequest;
(function (CreateImportJobRequest) {
    CreateImportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateImportJobRequest.isa = function (o) { return __isa(o, "CreateImportJobRequest"); };
})(CreateImportJobRequest || (CreateImportJobRequest = {}));
export var CreateImportJobResponse;
(function (CreateImportJobResponse) {
    CreateImportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateImportJobResponse.isa = function (o) { return __isa(o, "CreateImportJobResponse"); };
})(CreateImportJobResponse || (CreateImportJobResponse = {}));
export var CreateJourneyRequest;
(function (CreateJourneyRequest) {
    CreateJourneyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateJourneyRequest.isa = function (o) { return __isa(o, "CreateJourneyRequest"); };
})(CreateJourneyRequest || (CreateJourneyRequest = {}));
export var CreateJourneyResponse;
(function (CreateJourneyResponse) {
    CreateJourneyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateJourneyResponse.isa = function (o) { return __isa(o, "CreateJourneyResponse"); };
})(CreateJourneyResponse || (CreateJourneyResponse = {}));
export var CreatePushTemplateRequest;
(function (CreatePushTemplateRequest) {
    CreatePushTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreatePushTemplateRequest.isa = function (o) { return __isa(o, "CreatePushTemplateRequest"); };
})(CreatePushTemplateRequest || (CreatePushTemplateRequest = {}));
export var CreatePushTemplateResponse;
(function (CreatePushTemplateResponse) {
    CreatePushTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreatePushTemplateResponse.isa = function (o) { return __isa(o, "CreatePushTemplateResponse"); };
})(CreatePushTemplateResponse || (CreatePushTemplateResponse = {}));
export var CreateRecommenderConfigurationRequest;
(function (CreateRecommenderConfigurationRequest) {
    CreateRecommenderConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateRecommenderConfigurationRequest.isa = function (o) {
        return __isa(o, "CreateRecommenderConfigurationRequest");
    };
})(CreateRecommenderConfigurationRequest || (CreateRecommenderConfigurationRequest = {}));
export var CreateRecommenderConfigurationResponse;
(function (CreateRecommenderConfigurationResponse) {
    CreateRecommenderConfigurationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateRecommenderConfigurationResponse.isa = function (o) {
        return __isa(o, "CreateRecommenderConfigurationResponse");
    };
})(CreateRecommenderConfigurationResponse || (CreateRecommenderConfigurationResponse = {}));
export var CreateRecommenderConfigurationShape;
(function (CreateRecommenderConfigurationShape) {
    CreateRecommenderConfigurationShape.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateRecommenderConfigurationShape.isa = function (o) {
        return __isa(o, "CreateRecommenderConfigurationShape");
    };
})(CreateRecommenderConfigurationShape || (CreateRecommenderConfigurationShape = {}));
export var CreateSegmentRequest;
(function (CreateSegmentRequest) {
    CreateSegmentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateSegmentRequest.isa = function (o) { return __isa(o, "CreateSegmentRequest"); };
})(CreateSegmentRequest || (CreateSegmentRequest = {}));
export var CreateSegmentResponse;
(function (CreateSegmentResponse) {
    CreateSegmentResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateSegmentResponse.isa = function (o) { return __isa(o, "CreateSegmentResponse"); };
})(CreateSegmentResponse || (CreateSegmentResponse = {}));
export var CreateSmsTemplateRequest;
(function (CreateSmsTemplateRequest) {
    CreateSmsTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateSmsTemplateRequest.isa = function (o) { return __isa(o, "CreateSmsTemplateRequest"); };
})(CreateSmsTemplateRequest || (CreateSmsTemplateRequest = {}));
export var CreateSmsTemplateResponse;
(function (CreateSmsTemplateResponse) {
    CreateSmsTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateSmsTemplateResponse.isa = function (o) { return __isa(o, "CreateSmsTemplateResponse"); };
})(CreateSmsTemplateResponse || (CreateSmsTemplateResponse = {}));
export var CreateTemplateMessageBody;
(function (CreateTemplateMessageBody) {
    CreateTemplateMessageBody.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateTemplateMessageBody.isa = function (o) { return __isa(o, "CreateTemplateMessageBody"); };
})(CreateTemplateMessageBody || (CreateTemplateMessageBody = {}));
export var CreateVoiceTemplateRequest;
(function (CreateVoiceTemplateRequest) {
    CreateVoiceTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateVoiceTemplateRequest.isa = function (o) { return __isa(o, "CreateVoiceTemplateRequest"); };
})(CreateVoiceTemplateRequest || (CreateVoiceTemplateRequest = {}));
export var CreateVoiceTemplateResponse;
(function (CreateVoiceTemplateResponse) {
    CreateVoiceTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CreateVoiceTemplateResponse.isa = function (o) { return __isa(o, "CreateVoiceTemplateResponse"); };
})(CreateVoiceTemplateResponse || (CreateVoiceTemplateResponse = {}));
export var CustomDeliveryConfiguration;
(function (CustomDeliveryConfiguration) {
    CustomDeliveryConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CustomDeliveryConfiguration.isa = function (o) { return __isa(o, "CustomDeliveryConfiguration"); };
})(CustomDeliveryConfiguration || (CustomDeliveryConfiguration = {}));
export var CustomMessageActivity;
(function (CustomMessageActivity) {
    CustomMessageActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    CustomMessageActivity.isa = function (o) { return __isa(o, "CustomMessageActivity"); };
})(CustomMessageActivity || (CustomMessageActivity = {}));
export var DefaultMessage;
(function (DefaultMessage) {
    DefaultMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DefaultMessage.isa = function (o) { return __isa(o, "DefaultMessage"); };
})(DefaultMessage || (DefaultMessage = {}));
export var DefaultPushNotificationMessage;
(function (DefaultPushNotificationMessage) {
    DefaultPushNotificationMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DefaultPushNotificationMessage.isa = function (o) { return __isa(o, "DefaultPushNotificationMessage"); };
})(DefaultPushNotificationMessage || (DefaultPushNotificationMessage = {}));
export var DefaultPushNotificationTemplate;
(function (DefaultPushNotificationTemplate) {
    DefaultPushNotificationTemplate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DefaultPushNotificationTemplate.isa = function (o) { return __isa(o, "DefaultPushNotificationTemplate"); };
})(DefaultPushNotificationTemplate || (DefaultPushNotificationTemplate = {}));
export var DeleteAdmChannelRequest;
(function (DeleteAdmChannelRequest) {
    DeleteAdmChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteAdmChannelRequest.isa = function (o) { return __isa(o, "DeleteAdmChannelRequest"); };
})(DeleteAdmChannelRequest || (DeleteAdmChannelRequest = {}));
export var DeleteAdmChannelResponse;
(function (DeleteAdmChannelResponse) {
    DeleteAdmChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteAdmChannelResponse.isa = function (o) { return __isa(o, "DeleteAdmChannelResponse"); };
})(DeleteAdmChannelResponse || (DeleteAdmChannelResponse = {}));
export var DeleteApnsChannelRequest;
(function (DeleteApnsChannelRequest) {
    DeleteApnsChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteApnsChannelRequest.isa = function (o) { return __isa(o, "DeleteApnsChannelRequest"); };
})(DeleteApnsChannelRequest || (DeleteApnsChannelRequest = {}));
export var DeleteApnsChannelResponse;
(function (DeleteApnsChannelResponse) {
    DeleteApnsChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteApnsChannelResponse.isa = function (o) { return __isa(o, "DeleteApnsChannelResponse"); };
})(DeleteApnsChannelResponse || (DeleteApnsChannelResponse = {}));
export var DeleteApnsSandboxChannelRequest;
(function (DeleteApnsSandboxChannelRequest) {
    DeleteApnsSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteApnsSandboxChannelRequest.isa = function (o) { return __isa(o, "DeleteApnsSandboxChannelRequest"); };
})(DeleteApnsSandboxChannelRequest || (DeleteApnsSandboxChannelRequest = {}));
export var DeleteApnsSandboxChannelResponse;
(function (DeleteApnsSandboxChannelResponse) {
    DeleteApnsSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteApnsSandboxChannelResponse.isa = function (o) { return __isa(o, "DeleteApnsSandboxChannelResponse"); };
})(DeleteApnsSandboxChannelResponse || (DeleteApnsSandboxChannelResponse = {}));
export var DeleteApnsVoipChannelRequest;
(function (DeleteApnsVoipChannelRequest) {
    DeleteApnsVoipChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteApnsVoipChannelRequest.isa = function (o) { return __isa(o, "DeleteApnsVoipChannelRequest"); };
})(DeleteApnsVoipChannelRequest || (DeleteApnsVoipChannelRequest = {}));
export var DeleteApnsVoipChannelResponse;
(function (DeleteApnsVoipChannelResponse) {
    DeleteApnsVoipChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteApnsVoipChannelResponse.isa = function (o) { return __isa(o, "DeleteApnsVoipChannelResponse"); };
})(DeleteApnsVoipChannelResponse || (DeleteApnsVoipChannelResponse = {}));
export var DeleteApnsVoipSandboxChannelRequest;
(function (DeleteApnsVoipSandboxChannelRequest) {
    DeleteApnsVoipSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteApnsVoipSandboxChannelRequest.isa = function (o) {
        return __isa(o, "DeleteApnsVoipSandboxChannelRequest");
    };
})(DeleteApnsVoipSandboxChannelRequest || (DeleteApnsVoipSandboxChannelRequest = {}));
export var DeleteApnsVoipSandboxChannelResponse;
(function (DeleteApnsVoipSandboxChannelResponse) {
    DeleteApnsVoipSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteApnsVoipSandboxChannelResponse.isa = function (o) {
        return __isa(o, "DeleteApnsVoipSandboxChannelResponse");
    };
})(DeleteApnsVoipSandboxChannelResponse || (DeleteApnsVoipSandboxChannelResponse = {}));
export var DeleteAppRequest;
(function (DeleteAppRequest) {
    DeleteAppRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteAppRequest.isa = function (o) { return __isa(o, "DeleteAppRequest"); };
})(DeleteAppRequest || (DeleteAppRequest = {}));
export var DeleteAppResponse;
(function (DeleteAppResponse) {
    DeleteAppResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteAppResponse.isa = function (o) { return __isa(o, "DeleteAppResponse"); };
})(DeleteAppResponse || (DeleteAppResponse = {}));
export var DeleteBaiduChannelRequest;
(function (DeleteBaiduChannelRequest) {
    DeleteBaiduChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBaiduChannelRequest.isa = function (o) { return __isa(o, "DeleteBaiduChannelRequest"); };
})(DeleteBaiduChannelRequest || (DeleteBaiduChannelRequest = {}));
export var DeleteBaiduChannelResponse;
(function (DeleteBaiduChannelResponse) {
    DeleteBaiduChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteBaiduChannelResponse.isa = function (o) { return __isa(o, "DeleteBaiduChannelResponse"); };
})(DeleteBaiduChannelResponse || (DeleteBaiduChannelResponse = {}));
export var DeleteCampaignRequest;
(function (DeleteCampaignRequest) {
    DeleteCampaignRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteCampaignRequest.isa = function (o) { return __isa(o, "DeleteCampaignRequest"); };
})(DeleteCampaignRequest || (DeleteCampaignRequest = {}));
export var DeleteCampaignResponse;
(function (DeleteCampaignResponse) {
    DeleteCampaignResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteCampaignResponse.isa = function (o) { return __isa(o, "DeleteCampaignResponse"); };
})(DeleteCampaignResponse || (DeleteCampaignResponse = {}));
export var DeleteEmailChannelRequest;
(function (DeleteEmailChannelRequest) {
    DeleteEmailChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteEmailChannelRequest.isa = function (o) { return __isa(o, "DeleteEmailChannelRequest"); };
})(DeleteEmailChannelRequest || (DeleteEmailChannelRequest = {}));
export var DeleteEmailChannelResponse;
(function (DeleteEmailChannelResponse) {
    DeleteEmailChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteEmailChannelResponse.isa = function (o) { return __isa(o, "DeleteEmailChannelResponse"); };
})(DeleteEmailChannelResponse || (DeleteEmailChannelResponse = {}));
export var DeleteEmailTemplateRequest;
(function (DeleteEmailTemplateRequest) {
    DeleteEmailTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteEmailTemplateRequest.isa = function (o) { return __isa(o, "DeleteEmailTemplateRequest"); };
})(DeleteEmailTemplateRequest || (DeleteEmailTemplateRequest = {}));
export var DeleteEmailTemplateResponse;
(function (DeleteEmailTemplateResponse) {
    DeleteEmailTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteEmailTemplateResponse.isa = function (o) { return __isa(o, "DeleteEmailTemplateResponse"); };
})(DeleteEmailTemplateResponse || (DeleteEmailTemplateResponse = {}));
export var DeleteEndpointRequest;
(function (DeleteEndpointRequest) {
    DeleteEndpointRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteEndpointRequest.isa = function (o) { return __isa(o, "DeleteEndpointRequest"); };
})(DeleteEndpointRequest || (DeleteEndpointRequest = {}));
export var DeleteEndpointResponse;
(function (DeleteEndpointResponse) {
    DeleteEndpointResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteEndpointResponse.isa = function (o) { return __isa(o, "DeleteEndpointResponse"); };
})(DeleteEndpointResponse || (DeleteEndpointResponse = {}));
export var DeleteEventStreamRequest;
(function (DeleteEventStreamRequest) {
    DeleteEventStreamRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteEventStreamRequest.isa = function (o) { return __isa(o, "DeleteEventStreamRequest"); };
})(DeleteEventStreamRequest || (DeleteEventStreamRequest = {}));
export var DeleteEventStreamResponse;
(function (DeleteEventStreamResponse) {
    DeleteEventStreamResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteEventStreamResponse.isa = function (o) { return __isa(o, "DeleteEventStreamResponse"); };
})(DeleteEventStreamResponse || (DeleteEventStreamResponse = {}));
export var DeleteGcmChannelRequest;
(function (DeleteGcmChannelRequest) {
    DeleteGcmChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteGcmChannelRequest.isa = function (o) { return __isa(o, "DeleteGcmChannelRequest"); };
})(DeleteGcmChannelRequest || (DeleteGcmChannelRequest = {}));
export var DeleteGcmChannelResponse;
(function (DeleteGcmChannelResponse) {
    DeleteGcmChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteGcmChannelResponse.isa = function (o) { return __isa(o, "DeleteGcmChannelResponse"); };
})(DeleteGcmChannelResponse || (DeleteGcmChannelResponse = {}));
export var DeleteJourneyRequest;
(function (DeleteJourneyRequest) {
    DeleteJourneyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteJourneyRequest.isa = function (o) { return __isa(o, "DeleteJourneyRequest"); };
})(DeleteJourneyRequest || (DeleteJourneyRequest = {}));
export var DeleteJourneyResponse;
(function (DeleteJourneyResponse) {
    DeleteJourneyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteJourneyResponse.isa = function (o) { return __isa(o, "DeleteJourneyResponse"); };
})(DeleteJourneyResponse || (DeleteJourneyResponse = {}));
export var DeletePushTemplateRequest;
(function (DeletePushTemplateRequest) {
    DeletePushTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeletePushTemplateRequest.isa = function (o) { return __isa(o, "DeletePushTemplateRequest"); };
})(DeletePushTemplateRequest || (DeletePushTemplateRequest = {}));
export var DeletePushTemplateResponse;
(function (DeletePushTemplateResponse) {
    DeletePushTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeletePushTemplateResponse.isa = function (o) { return __isa(o, "DeletePushTemplateResponse"); };
})(DeletePushTemplateResponse || (DeletePushTemplateResponse = {}));
export var DeleteRecommenderConfigurationRequest;
(function (DeleteRecommenderConfigurationRequest) {
    DeleteRecommenderConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteRecommenderConfigurationRequest.isa = function (o) {
        return __isa(o, "DeleteRecommenderConfigurationRequest");
    };
})(DeleteRecommenderConfigurationRequest || (DeleteRecommenderConfigurationRequest = {}));
export var DeleteRecommenderConfigurationResponse;
(function (DeleteRecommenderConfigurationResponse) {
    DeleteRecommenderConfigurationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteRecommenderConfigurationResponse.isa = function (o) {
        return __isa(o, "DeleteRecommenderConfigurationResponse");
    };
})(DeleteRecommenderConfigurationResponse || (DeleteRecommenderConfigurationResponse = {}));
export var DeleteSegmentRequest;
(function (DeleteSegmentRequest) {
    DeleteSegmentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteSegmentRequest.isa = function (o) { return __isa(o, "DeleteSegmentRequest"); };
})(DeleteSegmentRequest || (DeleteSegmentRequest = {}));
export var DeleteSegmentResponse;
(function (DeleteSegmentResponse) {
    DeleteSegmentResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteSegmentResponse.isa = function (o) { return __isa(o, "DeleteSegmentResponse"); };
})(DeleteSegmentResponse || (DeleteSegmentResponse = {}));
export var DeleteSmsChannelRequest;
(function (DeleteSmsChannelRequest) {
    DeleteSmsChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteSmsChannelRequest.isa = function (o) { return __isa(o, "DeleteSmsChannelRequest"); };
})(DeleteSmsChannelRequest || (DeleteSmsChannelRequest = {}));
export var DeleteSmsChannelResponse;
(function (DeleteSmsChannelResponse) {
    DeleteSmsChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteSmsChannelResponse.isa = function (o) { return __isa(o, "DeleteSmsChannelResponse"); };
})(DeleteSmsChannelResponse || (DeleteSmsChannelResponse = {}));
export var DeleteSmsTemplateRequest;
(function (DeleteSmsTemplateRequest) {
    DeleteSmsTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteSmsTemplateRequest.isa = function (o) { return __isa(o, "DeleteSmsTemplateRequest"); };
})(DeleteSmsTemplateRequest || (DeleteSmsTemplateRequest = {}));
export var DeleteSmsTemplateResponse;
(function (DeleteSmsTemplateResponse) {
    DeleteSmsTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteSmsTemplateResponse.isa = function (o) { return __isa(o, "DeleteSmsTemplateResponse"); };
})(DeleteSmsTemplateResponse || (DeleteSmsTemplateResponse = {}));
export var DeleteUserEndpointsRequest;
(function (DeleteUserEndpointsRequest) {
    DeleteUserEndpointsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteUserEndpointsRequest.isa = function (o) { return __isa(o, "DeleteUserEndpointsRequest"); };
})(DeleteUserEndpointsRequest || (DeleteUserEndpointsRequest = {}));
export var DeleteUserEndpointsResponse;
(function (DeleteUserEndpointsResponse) {
    DeleteUserEndpointsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteUserEndpointsResponse.isa = function (o) { return __isa(o, "DeleteUserEndpointsResponse"); };
})(DeleteUserEndpointsResponse || (DeleteUserEndpointsResponse = {}));
export var DeleteVoiceChannelRequest;
(function (DeleteVoiceChannelRequest) {
    DeleteVoiceChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteVoiceChannelRequest.isa = function (o) { return __isa(o, "DeleteVoiceChannelRequest"); };
})(DeleteVoiceChannelRequest || (DeleteVoiceChannelRequest = {}));
export var DeleteVoiceChannelResponse;
(function (DeleteVoiceChannelResponse) {
    DeleteVoiceChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteVoiceChannelResponse.isa = function (o) { return __isa(o, "DeleteVoiceChannelResponse"); };
})(DeleteVoiceChannelResponse || (DeleteVoiceChannelResponse = {}));
export var DeleteVoiceTemplateRequest;
(function (DeleteVoiceTemplateRequest) {
    DeleteVoiceTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteVoiceTemplateRequest.isa = function (o) { return __isa(o, "DeleteVoiceTemplateRequest"); };
})(DeleteVoiceTemplateRequest || (DeleteVoiceTemplateRequest = {}));
export var DeleteVoiceTemplateResponse;
(function (DeleteVoiceTemplateResponse) {
    DeleteVoiceTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DeleteVoiceTemplateResponse.isa = function (o) { return __isa(o, "DeleteVoiceTemplateResponse"); };
})(DeleteVoiceTemplateResponse || (DeleteVoiceTemplateResponse = {}));
export var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["DUPLICATE"] = "DUPLICATE";
    DeliveryStatus["OPT_OUT"] = "OPT_OUT";
    DeliveryStatus["PERMANENT_FAILURE"] = "PERMANENT_FAILURE";
    DeliveryStatus["SUCCESSFUL"] = "SUCCESSFUL";
    DeliveryStatus["TEMPORARY_FAILURE"] = "TEMPORARY_FAILURE";
    DeliveryStatus["THROTTLED"] = "THROTTLED";
    DeliveryStatus["UNKNOWN_FAILURE"] = "UNKNOWN_FAILURE";
})(DeliveryStatus || (DeliveryStatus = {}));
export var DimensionType;
(function (DimensionType) {
    DimensionType["EXCLUSIVE"] = "EXCLUSIVE";
    DimensionType["INCLUSIVE"] = "INCLUSIVE";
})(DimensionType || (DimensionType = {}));
export var DirectMessageConfiguration;
(function (DirectMessageConfiguration) {
    DirectMessageConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    DirectMessageConfiguration.isa = function (o) { return __isa(o, "DirectMessageConfiguration"); };
})(DirectMessageConfiguration || (DirectMessageConfiguration = {}));
export var Duration;
(function (Duration) {
    Duration["DAY_14"] = "DAY_14";
    Duration["DAY_30"] = "DAY_30";
    Duration["DAY_7"] = "DAY_7";
    Duration["HR_24"] = "HR_24";
})(Duration || (Duration = {}));
export var EmailChannelRequest;
(function (EmailChannelRequest) {
    EmailChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EmailChannelRequest.isa = function (o) { return __isa(o, "EmailChannelRequest"); };
})(EmailChannelRequest || (EmailChannelRequest = {}));
export var EmailChannelResponse;
(function (EmailChannelResponse) {
    EmailChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EmailChannelResponse.isa = function (o) { return __isa(o, "EmailChannelResponse"); };
})(EmailChannelResponse || (EmailChannelResponse = {}));
export var EmailMessage;
(function (EmailMessage) {
    EmailMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EmailMessage.isa = function (o) { return __isa(o, "EmailMessage"); };
})(EmailMessage || (EmailMessage = {}));
export var EmailMessageActivity;
(function (EmailMessageActivity) {
    EmailMessageActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EmailMessageActivity.isa = function (o) { return __isa(o, "EmailMessageActivity"); };
})(EmailMessageActivity || (EmailMessageActivity = {}));
export var EmailTemplateRequest;
(function (EmailTemplateRequest) {
    EmailTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EmailTemplateRequest.isa = function (o) { return __isa(o, "EmailTemplateRequest"); };
})(EmailTemplateRequest || (EmailTemplateRequest = {}));
export var EmailTemplateResponse;
(function (EmailTemplateResponse) {
    EmailTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EmailTemplateResponse.isa = function (o) { return __isa(o, "EmailTemplateResponse"); };
})(EmailTemplateResponse || (EmailTemplateResponse = {}));
export var EndpointBatchItem;
(function (EndpointBatchItem) {
    EndpointBatchItem.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointBatchItem.isa = function (o) { return __isa(o, "EndpointBatchItem"); };
})(EndpointBatchItem || (EndpointBatchItem = {}));
export var EndpointBatchRequest;
(function (EndpointBatchRequest) {
    EndpointBatchRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointBatchRequest.isa = function (o) { return __isa(o, "EndpointBatchRequest"); };
})(EndpointBatchRequest || (EndpointBatchRequest = {}));
export var EndpointDemographic;
(function (EndpointDemographic) {
    EndpointDemographic.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointDemographic.isa = function (o) { return __isa(o, "EndpointDemographic"); };
})(EndpointDemographic || (EndpointDemographic = {}));
export var EndpointItemResponse;
(function (EndpointItemResponse) {
    EndpointItemResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointItemResponse.isa = function (o) { return __isa(o, "EndpointItemResponse"); };
})(EndpointItemResponse || (EndpointItemResponse = {}));
export var EndpointLocation;
(function (EndpointLocation) {
    EndpointLocation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointLocation.isa = function (o) { return __isa(o, "EndpointLocation"); };
})(EndpointLocation || (EndpointLocation = {}));
export var EndpointMessageResult;
(function (EndpointMessageResult) {
    EndpointMessageResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointMessageResult.isa = function (o) { return __isa(o, "EndpointMessageResult"); };
})(EndpointMessageResult || (EndpointMessageResult = {}));
export var EndpointRequest;
(function (EndpointRequest) {
    EndpointRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointRequest.isa = function (o) { return __isa(o, "EndpointRequest"); };
})(EndpointRequest || (EndpointRequest = {}));
export var EndpointResponse;
(function (EndpointResponse) {
    EndpointResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointResponse.isa = function (o) { return __isa(o, "EndpointResponse"); };
})(EndpointResponse || (EndpointResponse = {}));
export var EndpointSendConfiguration;
(function (EndpointSendConfiguration) {
    EndpointSendConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointSendConfiguration.isa = function (o) { return __isa(o, "EndpointSendConfiguration"); };
})(EndpointSendConfiguration || (EndpointSendConfiguration = {}));
export var EndpointsResponse;
(function (EndpointsResponse) {
    EndpointsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointsResponse.isa = function (o) { return __isa(o, "EndpointsResponse"); };
})(EndpointsResponse || (EndpointsResponse = {}));
export var EndpointUser;
(function (EndpointUser) {
    EndpointUser.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EndpointUser.isa = function (o) { return __isa(o, "EndpointUser"); };
})(EndpointUser || (EndpointUser = {}));
export var Event;
(function (Event) {
    Event.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Event.isa = function (o) { return __isa(o, "Event"); };
})(Event || (Event = {}));
export var EventCondition;
(function (EventCondition) {
    EventCondition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EventCondition.isa = function (o) { return __isa(o, "EventCondition"); };
})(EventCondition || (EventCondition = {}));
export var EventDimensions;
(function (EventDimensions) {
    EventDimensions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EventDimensions.isa = function (o) { return __isa(o, "EventDimensions"); };
})(EventDimensions || (EventDimensions = {}));
export var EventItemResponse;
(function (EventItemResponse) {
    EventItemResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EventItemResponse.isa = function (o) { return __isa(o, "EventItemResponse"); };
})(EventItemResponse || (EventItemResponse = {}));
export var EventsBatch;
(function (EventsBatch) {
    EventsBatch.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EventsBatch.isa = function (o) { return __isa(o, "EventsBatch"); };
})(EventsBatch || (EventsBatch = {}));
export var EventsRequest;
(function (EventsRequest) {
    EventsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EventsRequest.isa = function (o) { return __isa(o, "EventsRequest"); };
})(EventsRequest || (EventsRequest = {}));
export var EventsResponse;
(function (EventsResponse) {
    EventsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EventsResponse.isa = function (o) { return __isa(o, "EventsResponse"); };
})(EventsResponse || (EventsResponse = {}));
export var EventStream;
(function (EventStream) {
    EventStream.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    EventStream.isa = function (o) { return __isa(o, "EventStream"); };
})(EventStream || (EventStream = {}));
export var ExportJobRequest;
(function (ExportJobRequest) {
    ExportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExportJobRequest.isa = function (o) { return __isa(o, "ExportJobRequest"); };
})(ExportJobRequest || (ExportJobRequest = {}));
export var ExportJobResource;
(function (ExportJobResource) {
    ExportJobResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExportJobResource.isa = function (o) { return __isa(o, "ExportJobResource"); };
})(ExportJobResource || (ExportJobResource = {}));
export var ExportJobResponse;
(function (ExportJobResponse) {
    ExportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExportJobResponse.isa = function (o) { return __isa(o, "ExportJobResponse"); };
})(ExportJobResponse || (ExportJobResponse = {}));
export var ExportJobsResponse;
(function (ExportJobsResponse) {
    ExportJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ExportJobsResponse.isa = function (o) { return __isa(o, "ExportJobsResponse"); };
})(ExportJobsResponse || (ExportJobsResponse = {}));
export var FilterType;
(function (FilterType) {
    FilterType["ENDPOINT"] = "ENDPOINT";
    FilterType["SYSTEM"] = "SYSTEM";
})(FilterType || (FilterType = {}));
export var ForbiddenException;
(function (ForbiddenException) {
    ForbiddenException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ForbiddenException.isa = function (o) { return __isa(o, "ForbiddenException"); };
})(ForbiddenException || (ForbiddenException = {}));
export var Format;
(function (Format) {
    Format["CSV"] = "CSV";
    Format["JSON"] = "JSON";
})(Format || (Format = {}));
export var Frequency;
(function (Frequency) {
    Frequency["DAILY"] = "DAILY";
    Frequency["EVENT"] = "EVENT";
    Frequency["HOURLY"] = "HOURLY";
    Frequency["MONTHLY"] = "MONTHLY";
    Frequency["ONCE"] = "ONCE";
    Frequency["WEEKLY"] = "WEEKLY";
})(Frequency || (Frequency = {}));
export var GCMChannelRequest;
(function (GCMChannelRequest) {
    GCMChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GCMChannelRequest.isa = function (o) { return __isa(o, "GCMChannelRequest"); };
})(GCMChannelRequest || (GCMChannelRequest = {}));
export var GCMChannelResponse;
(function (GCMChannelResponse) {
    GCMChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GCMChannelResponse.isa = function (o) { return __isa(o, "GCMChannelResponse"); };
})(GCMChannelResponse || (GCMChannelResponse = {}));
export var GCMMessage;
(function (GCMMessage) {
    GCMMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GCMMessage.isa = function (o) { return __isa(o, "GCMMessage"); };
})(GCMMessage || (GCMMessage = {}));
export var GetAdmChannelRequest;
(function (GetAdmChannelRequest) {
    GetAdmChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetAdmChannelRequest.isa = function (o) { return __isa(o, "GetAdmChannelRequest"); };
})(GetAdmChannelRequest || (GetAdmChannelRequest = {}));
export var GetAdmChannelResponse;
(function (GetAdmChannelResponse) {
    GetAdmChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetAdmChannelResponse.isa = function (o) { return __isa(o, "GetAdmChannelResponse"); };
})(GetAdmChannelResponse || (GetAdmChannelResponse = {}));
export var GetApnsChannelRequest;
(function (GetApnsChannelRequest) {
    GetApnsChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApnsChannelRequest.isa = function (o) { return __isa(o, "GetApnsChannelRequest"); };
})(GetApnsChannelRequest || (GetApnsChannelRequest = {}));
export var GetApnsChannelResponse;
(function (GetApnsChannelResponse) {
    GetApnsChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApnsChannelResponse.isa = function (o) { return __isa(o, "GetApnsChannelResponse"); };
})(GetApnsChannelResponse || (GetApnsChannelResponse = {}));
export var GetApnsSandboxChannelRequest;
(function (GetApnsSandboxChannelRequest) {
    GetApnsSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApnsSandboxChannelRequest.isa = function (o) { return __isa(o, "GetApnsSandboxChannelRequest"); };
})(GetApnsSandboxChannelRequest || (GetApnsSandboxChannelRequest = {}));
export var GetApnsSandboxChannelResponse;
(function (GetApnsSandboxChannelResponse) {
    GetApnsSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApnsSandboxChannelResponse.isa = function (o) { return __isa(o, "GetApnsSandboxChannelResponse"); };
})(GetApnsSandboxChannelResponse || (GetApnsSandboxChannelResponse = {}));
export var GetApnsVoipChannelRequest;
(function (GetApnsVoipChannelRequest) {
    GetApnsVoipChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApnsVoipChannelRequest.isa = function (o) { return __isa(o, "GetApnsVoipChannelRequest"); };
})(GetApnsVoipChannelRequest || (GetApnsVoipChannelRequest = {}));
export var GetApnsVoipChannelResponse;
(function (GetApnsVoipChannelResponse) {
    GetApnsVoipChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApnsVoipChannelResponse.isa = function (o) { return __isa(o, "GetApnsVoipChannelResponse"); };
})(GetApnsVoipChannelResponse || (GetApnsVoipChannelResponse = {}));
export var GetApnsVoipSandboxChannelRequest;
(function (GetApnsVoipSandboxChannelRequest) {
    GetApnsVoipSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApnsVoipSandboxChannelRequest.isa = function (o) { return __isa(o, "GetApnsVoipSandboxChannelRequest"); };
})(GetApnsVoipSandboxChannelRequest || (GetApnsVoipSandboxChannelRequest = {}));
export var GetApnsVoipSandboxChannelResponse;
(function (GetApnsVoipSandboxChannelResponse) {
    GetApnsVoipSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApnsVoipSandboxChannelResponse.isa = function (o) { return __isa(o, "GetApnsVoipSandboxChannelResponse"); };
})(GetApnsVoipSandboxChannelResponse || (GetApnsVoipSandboxChannelResponse = {}));
export var GetApplicationDateRangeKpiRequest;
(function (GetApplicationDateRangeKpiRequest) {
    GetApplicationDateRangeKpiRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApplicationDateRangeKpiRequest.isa = function (o) { return __isa(o, "GetApplicationDateRangeKpiRequest"); };
})(GetApplicationDateRangeKpiRequest || (GetApplicationDateRangeKpiRequest = {}));
export var GetApplicationDateRangeKpiResponse;
(function (GetApplicationDateRangeKpiResponse) {
    GetApplicationDateRangeKpiResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApplicationDateRangeKpiResponse.isa = function (o) {
        return __isa(o, "GetApplicationDateRangeKpiResponse");
    };
})(GetApplicationDateRangeKpiResponse || (GetApplicationDateRangeKpiResponse = {}));
export var GetApplicationSettingsRequest;
(function (GetApplicationSettingsRequest) {
    GetApplicationSettingsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApplicationSettingsRequest.isa = function (o) { return __isa(o, "GetApplicationSettingsRequest"); };
})(GetApplicationSettingsRequest || (GetApplicationSettingsRequest = {}));
export var GetApplicationSettingsResponse;
(function (GetApplicationSettingsResponse) {
    GetApplicationSettingsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetApplicationSettingsResponse.isa = function (o) { return __isa(o, "GetApplicationSettingsResponse"); };
})(GetApplicationSettingsResponse || (GetApplicationSettingsResponse = {}));
export var GetAppRequest;
(function (GetAppRequest) {
    GetAppRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetAppRequest.isa = function (o) { return __isa(o, "GetAppRequest"); };
})(GetAppRequest || (GetAppRequest = {}));
export var GetAppResponse;
(function (GetAppResponse) {
    GetAppResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetAppResponse.isa = function (o) { return __isa(o, "GetAppResponse"); };
})(GetAppResponse || (GetAppResponse = {}));
export var GetAppsRequest;
(function (GetAppsRequest) {
    GetAppsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetAppsRequest.isa = function (o) { return __isa(o, "GetAppsRequest"); };
})(GetAppsRequest || (GetAppsRequest = {}));
export var GetAppsResponse;
(function (GetAppsResponse) {
    GetAppsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetAppsResponse.isa = function (o) { return __isa(o, "GetAppsResponse"); };
})(GetAppsResponse || (GetAppsResponse = {}));
export var GetBaiduChannelRequest;
(function (GetBaiduChannelRequest) {
    GetBaiduChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBaiduChannelRequest.isa = function (o) { return __isa(o, "GetBaiduChannelRequest"); };
})(GetBaiduChannelRequest || (GetBaiduChannelRequest = {}));
export var GetBaiduChannelResponse;
(function (GetBaiduChannelResponse) {
    GetBaiduChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetBaiduChannelResponse.isa = function (o) { return __isa(o, "GetBaiduChannelResponse"); };
})(GetBaiduChannelResponse || (GetBaiduChannelResponse = {}));
export var GetCampaignActivitiesRequest;
(function (GetCampaignActivitiesRequest) {
    GetCampaignActivitiesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignActivitiesRequest.isa = function (o) { return __isa(o, "GetCampaignActivitiesRequest"); };
})(GetCampaignActivitiesRequest || (GetCampaignActivitiesRequest = {}));
export var GetCampaignActivitiesResponse;
(function (GetCampaignActivitiesResponse) {
    GetCampaignActivitiesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignActivitiesResponse.isa = function (o) { return __isa(o, "GetCampaignActivitiesResponse"); };
})(GetCampaignActivitiesResponse || (GetCampaignActivitiesResponse = {}));
export var GetCampaignDateRangeKpiRequest;
(function (GetCampaignDateRangeKpiRequest) {
    GetCampaignDateRangeKpiRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignDateRangeKpiRequest.isa = function (o) { return __isa(o, "GetCampaignDateRangeKpiRequest"); };
})(GetCampaignDateRangeKpiRequest || (GetCampaignDateRangeKpiRequest = {}));
export var GetCampaignDateRangeKpiResponse;
(function (GetCampaignDateRangeKpiResponse) {
    GetCampaignDateRangeKpiResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignDateRangeKpiResponse.isa = function (o) { return __isa(o, "GetCampaignDateRangeKpiResponse"); };
})(GetCampaignDateRangeKpiResponse || (GetCampaignDateRangeKpiResponse = {}));
export var GetCampaignRequest;
(function (GetCampaignRequest) {
    GetCampaignRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignRequest.isa = function (o) { return __isa(o, "GetCampaignRequest"); };
})(GetCampaignRequest || (GetCampaignRequest = {}));
export var GetCampaignResponse;
(function (GetCampaignResponse) {
    GetCampaignResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignResponse.isa = function (o) { return __isa(o, "GetCampaignResponse"); };
})(GetCampaignResponse || (GetCampaignResponse = {}));
export var GetCampaignsRequest;
(function (GetCampaignsRequest) {
    GetCampaignsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignsRequest.isa = function (o) { return __isa(o, "GetCampaignsRequest"); };
})(GetCampaignsRequest || (GetCampaignsRequest = {}));
export var GetCampaignsResponse;
(function (GetCampaignsResponse) {
    GetCampaignsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignsResponse.isa = function (o) { return __isa(o, "GetCampaignsResponse"); };
})(GetCampaignsResponse || (GetCampaignsResponse = {}));
export var GetCampaignVersionRequest;
(function (GetCampaignVersionRequest) {
    GetCampaignVersionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignVersionRequest.isa = function (o) { return __isa(o, "GetCampaignVersionRequest"); };
})(GetCampaignVersionRequest || (GetCampaignVersionRequest = {}));
export var GetCampaignVersionResponse;
(function (GetCampaignVersionResponse) {
    GetCampaignVersionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignVersionResponse.isa = function (o) { return __isa(o, "GetCampaignVersionResponse"); };
})(GetCampaignVersionResponse || (GetCampaignVersionResponse = {}));
export var GetCampaignVersionsRequest;
(function (GetCampaignVersionsRequest) {
    GetCampaignVersionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignVersionsRequest.isa = function (o) { return __isa(o, "GetCampaignVersionsRequest"); };
})(GetCampaignVersionsRequest || (GetCampaignVersionsRequest = {}));
export var GetCampaignVersionsResponse;
(function (GetCampaignVersionsResponse) {
    GetCampaignVersionsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetCampaignVersionsResponse.isa = function (o) { return __isa(o, "GetCampaignVersionsResponse"); };
})(GetCampaignVersionsResponse || (GetCampaignVersionsResponse = {}));
export var GetChannelsRequest;
(function (GetChannelsRequest) {
    GetChannelsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetChannelsRequest.isa = function (o) { return __isa(o, "GetChannelsRequest"); };
})(GetChannelsRequest || (GetChannelsRequest = {}));
export var GetChannelsResponse;
(function (GetChannelsResponse) {
    GetChannelsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetChannelsResponse.isa = function (o) { return __isa(o, "GetChannelsResponse"); };
})(GetChannelsResponse || (GetChannelsResponse = {}));
export var GetEmailChannelRequest;
(function (GetEmailChannelRequest) {
    GetEmailChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetEmailChannelRequest.isa = function (o) { return __isa(o, "GetEmailChannelRequest"); };
})(GetEmailChannelRequest || (GetEmailChannelRequest = {}));
export var GetEmailChannelResponse;
(function (GetEmailChannelResponse) {
    GetEmailChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetEmailChannelResponse.isa = function (o) { return __isa(o, "GetEmailChannelResponse"); };
})(GetEmailChannelResponse || (GetEmailChannelResponse = {}));
export var GetEmailTemplateRequest;
(function (GetEmailTemplateRequest) {
    GetEmailTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetEmailTemplateRequest.isa = function (o) { return __isa(o, "GetEmailTemplateRequest"); };
})(GetEmailTemplateRequest || (GetEmailTemplateRequest = {}));
export var GetEmailTemplateResponse;
(function (GetEmailTemplateResponse) {
    GetEmailTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetEmailTemplateResponse.isa = function (o) { return __isa(o, "GetEmailTemplateResponse"); };
})(GetEmailTemplateResponse || (GetEmailTemplateResponse = {}));
export var GetEndpointRequest;
(function (GetEndpointRequest) {
    GetEndpointRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetEndpointRequest.isa = function (o) { return __isa(o, "GetEndpointRequest"); };
})(GetEndpointRequest || (GetEndpointRequest = {}));
export var GetEndpointResponse;
(function (GetEndpointResponse) {
    GetEndpointResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetEndpointResponse.isa = function (o) { return __isa(o, "GetEndpointResponse"); };
})(GetEndpointResponse || (GetEndpointResponse = {}));
export var GetEventStreamRequest;
(function (GetEventStreamRequest) {
    GetEventStreamRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetEventStreamRequest.isa = function (o) { return __isa(o, "GetEventStreamRequest"); };
})(GetEventStreamRequest || (GetEventStreamRequest = {}));
export var GetEventStreamResponse;
(function (GetEventStreamResponse) {
    GetEventStreamResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetEventStreamResponse.isa = function (o) { return __isa(o, "GetEventStreamResponse"); };
})(GetEventStreamResponse || (GetEventStreamResponse = {}));
export var GetExportJobRequest;
(function (GetExportJobRequest) {
    GetExportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetExportJobRequest.isa = function (o) { return __isa(o, "GetExportJobRequest"); };
})(GetExportJobRequest || (GetExportJobRequest = {}));
export var GetExportJobResponse;
(function (GetExportJobResponse) {
    GetExportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetExportJobResponse.isa = function (o) { return __isa(o, "GetExportJobResponse"); };
})(GetExportJobResponse || (GetExportJobResponse = {}));
export var GetExportJobsRequest;
(function (GetExportJobsRequest) {
    GetExportJobsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetExportJobsRequest.isa = function (o) { return __isa(o, "GetExportJobsRequest"); };
})(GetExportJobsRequest || (GetExportJobsRequest = {}));
export var GetExportJobsResponse;
(function (GetExportJobsResponse) {
    GetExportJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetExportJobsResponse.isa = function (o) { return __isa(o, "GetExportJobsResponse"); };
})(GetExportJobsResponse || (GetExportJobsResponse = {}));
export var GetGcmChannelRequest;
(function (GetGcmChannelRequest) {
    GetGcmChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetGcmChannelRequest.isa = function (o) { return __isa(o, "GetGcmChannelRequest"); };
})(GetGcmChannelRequest || (GetGcmChannelRequest = {}));
export var GetGcmChannelResponse;
(function (GetGcmChannelResponse) {
    GetGcmChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetGcmChannelResponse.isa = function (o) { return __isa(o, "GetGcmChannelResponse"); };
})(GetGcmChannelResponse || (GetGcmChannelResponse = {}));
export var GetImportJobRequest;
(function (GetImportJobRequest) {
    GetImportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetImportJobRequest.isa = function (o) { return __isa(o, "GetImportJobRequest"); };
})(GetImportJobRequest || (GetImportJobRequest = {}));
export var GetImportJobResponse;
(function (GetImportJobResponse) {
    GetImportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetImportJobResponse.isa = function (o) { return __isa(o, "GetImportJobResponse"); };
})(GetImportJobResponse || (GetImportJobResponse = {}));
export var GetImportJobsRequest;
(function (GetImportJobsRequest) {
    GetImportJobsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetImportJobsRequest.isa = function (o) { return __isa(o, "GetImportJobsRequest"); };
})(GetImportJobsRequest || (GetImportJobsRequest = {}));
export var GetImportJobsResponse;
(function (GetImportJobsResponse) {
    GetImportJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetImportJobsResponse.isa = function (o) { return __isa(o, "GetImportJobsResponse"); };
})(GetImportJobsResponse || (GetImportJobsResponse = {}));
export var GetJourneyDateRangeKpiRequest;
(function (GetJourneyDateRangeKpiRequest) {
    GetJourneyDateRangeKpiRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetJourneyDateRangeKpiRequest.isa = function (o) { return __isa(o, "GetJourneyDateRangeKpiRequest"); };
})(GetJourneyDateRangeKpiRequest || (GetJourneyDateRangeKpiRequest = {}));
export var GetJourneyDateRangeKpiResponse;
(function (GetJourneyDateRangeKpiResponse) {
    GetJourneyDateRangeKpiResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetJourneyDateRangeKpiResponse.isa = function (o) { return __isa(o, "GetJourneyDateRangeKpiResponse"); };
})(GetJourneyDateRangeKpiResponse || (GetJourneyDateRangeKpiResponse = {}));
export var GetJourneyExecutionActivityMetricsRequest;
(function (GetJourneyExecutionActivityMetricsRequest) {
    GetJourneyExecutionActivityMetricsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetJourneyExecutionActivityMetricsRequest.isa = function (o) {
        return __isa(o, "GetJourneyExecutionActivityMetricsRequest");
    };
})(GetJourneyExecutionActivityMetricsRequest || (GetJourneyExecutionActivityMetricsRequest = {}));
export var GetJourneyExecutionActivityMetricsResponse;
(function (GetJourneyExecutionActivityMetricsResponse) {
    GetJourneyExecutionActivityMetricsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetJourneyExecutionActivityMetricsResponse.isa = function (o) {
        return __isa(o, "GetJourneyExecutionActivityMetricsResponse");
    };
})(GetJourneyExecutionActivityMetricsResponse || (GetJourneyExecutionActivityMetricsResponse = {}));
export var GetJourneyExecutionMetricsRequest;
(function (GetJourneyExecutionMetricsRequest) {
    GetJourneyExecutionMetricsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetJourneyExecutionMetricsRequest.isa = function (o) { return __isa(o, "GetJourneyExecutionMetricsRequest"); };
})(GetJourneyExecutionMetricsRequest || (GetJourneyExecutionMetricsRequest = {}));
export var GetJourneyExecutionMetricsResponse;
(function (GetJourneyExecutionMetricsResponse) {
    GetJourneyExecutionMetricsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetJourneyExecutionMetricsResponse.isa = function (o) {
        return __isa(o, "GetJourneyExecutionMetricsResponse");
    };
})(GetJourneyExecutionMetricsResponse || (GetJourneyExecutionMetricsResponse = {}));
export var GetJourneyRequest;
(function (GetJourneyRequest) {
    GetJourneyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetJourneyRequest.isa = function (o) { return __isa(o, "GetJourneyRequest"); };
})(GetJourneyRequest || (GetJourneyRequest = {}));
export var GetJourneyResponse;
(function (GetJourneyResponse) {
    GetJourneyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetJourneyResponse.isa = function (o) { return __isa(o, "GetJourneyResponse"); };
})(GetJourneyResponse || (GetJourneyResponse = {}));
export var GetPushTemplateRequest;
(function (GetPushTemplateRequest) {
    GetPushTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetPushTemplateRequest.isa = function (o) { return __isa(o, "GetPushTemplateRequest"); };
})(GetPushTemplateRequest || (GetPushTemplateRequest = {}));
export var GetPushTemplateResponse;
(function (GetPushTemplateResponse) {
    GetPushTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetPushTemplateResponse.isa = function (o) { return __isa(o, "GetPushTemplateResponse"); };
})(GetPushTemplateResponse || (GetPushTemplateResponse = {}));
export var GetRecommenderConfigurationRequest;
(function (GetRecommenderConfigurationRequest) {
    GetRecommenderConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetRecommenderConfigurationRequest.isa = function (o) {
        return __isa(o, "GetRecommenderConfigurationRequest");
    };
})(GetRecommenderConfigurationRequest || (GetRecommenderConfigurationRequest = {}));
export var GetRecommenderConfigurationResponse;
(function (GetRecommenderConfigurationResponse) {
    GetRecommenderConfigurationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetRecommenderConfigurationResponse.isa = function (o) {
        return __isa(o, "GetRecommenderConfigurationResponse");
    };
})(GetRecommenderConfigurationResponse || (GetRecommenderConfigurationResponse = {}));
export var GetRecommenderConfigurationsRequest;
(function (GetRecommenderConfigurationsRequest) {
    GetRecommenderConfigurationsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetRecommenderConfigurationsRequest.isa = function (o) {
        return __isa(o, "GetRecommenderConfigurationsRequest");
    };
})(GetRecommenderConfigurationsRequest || (GetRecommenderConfigurationsRequest = {}));
export var GetRecommenderConfigurationsResponse;
(function (GetRecommenderConfigurationsResponse) {
    GetRecommenderConfigurationsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetRecommenderConfigurationsResponse.isa = function (o) {
        return __isa(o, "GetRecommenderConfigurationsResponse");
    };
})(GetRecommenderConfigurationsResponse || (GetRecommenderConfigurationsResponse = {}));
export var GetSegmentExportJobsRequest;
(function (GetSegmentExportJobsRequest) {
    GetSegmentExportJobsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentExportJobsRequest.isa = function (o) { return __isa(o, "GetSegmentExportJobsRequest"); };
})(GetSegmentExportJobsRequest || (GetSegmentExportJobsRequest = {}));
export var GetSegmentExportJobsResponse;
(function (GetSegmentExportJobsResponse) {
    GetSegmentExportJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentExportJobsResponse.isa = function (o) { return __isa(o, "GetSegmentExportJobsResponse"); };
})(GetSegmentExportJobsResponse || (GetSegmentExportJobsResponse = {}));
export var GetSegmentImportJobsRequest;
(function (GetSegmentImportJobsRequest) {
    GetSegmentImportJobsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentImportJobsRequest.isa = function (o) { return __isa(o, "GetSegmentImportJobsRequest"); };
})(GetSegmentImportJobsRequest || (GetSegmentImportJobsRequest = {}));
export var GetSegmentImportJobsResponse;
(function (GetSegmentImportJobsResponse) {
    GetSegmentImportJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentImportJobsResponse.isa = function (o) { return __isa(o, "GetSegmentImportJobsResponse"); };
})(GetSegmentImportJobsResponse || (GetSegmentImportJobsResponse = {}));
export var GetSegmentRequest;
(function (GetSegmentRequest) {
    GetSegmentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentRequest.isa = function (o) { return __isa(o, "GetSegmentRequest"); };
})(GetSegmentRequest || (GetSegmentRequest = {}));
export var GetSegmentResponse;
(function (GetSegmentResponse) {
    GetSegmentResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentResponse.isa = function (o) { return __isa(o, "GetSegmentResponse"); };
})(GetSegmentResponse || (GetSegmentResponse = {}));
export var GetSegmentsRequest;
(function (GetSegmentsRequest) {
    GetSegmentsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentsRequest.isa = function (o) { return __isa(o, "GetSegmentsRequest"); };
})(GetSegmentsRequest || (GetSegmentsRequest = {}));
export var GetSegmentsResponse;
(function (GetSegmentsResponse) {
    GetSegmentsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentsResponse.isa = function (o) { return __isa(o, "GetSegmentsResponse"); };
})(GetSegmentsResponse || (GetSegmentsResponse = {}));
export var GetSegmentVersionRequest;
(function (GetSegmentVersionRequest) {
    GetSegmentVersionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentVersionRequest.isa = function (o) { return __isa(o, "GetSegmentVersionRequest"); };
})(GetSegmentVersionRequest || (GetSegmentVersionRequest = {}));
export var GetSegmentVersionResponse;
(function (GetSegmentVersionResponse) {
    GetSegmentVersionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentVersionResponse.isa = function (o) { return __isa(o, "GetSegmentVersionResponse"); };
})(GetSegmentVersionResponse || (GetSegmentVersionResponse = {}));
export var GetSegmentVersionsRequest;
(function (GetSegmentVersionsRequest) {
    GetSegmentVersionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentVersionsRequest.isa = function (o) { return __isa(o, "GetSegmentVersionsRequest"); };
})(GetSegmentVersionsRequest || (GetSegmentVersionsRequest = {}));
export var GetSegmentVersionsResponse;
(function (GetSegmentVersionsResponse) {
    GetSegmentVersionsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSegmentVersionsResponse.isa = function (o) { return __isa(o, "GetSegmentVersionsResponse"); };
})(GetSegmentVersionsResponse || (GetSegmentVersionsResponse = {}));
export var GetSmsChannelRequest;
(function (GetSmsChannelRequest) {
    GetSmsChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSmsChannelRequest.isa = function (o) { return __isa(o, "GetSmsChannelRequest"); };
})(GetSmsChannelRequest || (GetSmsChannelRequest = {}));
export var GetSmsChannelResponse;
(function (GetSmsChannelResponse) {
    GetSmsChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSmsChannelResponse.isa = function (o) { return __isa(o, "GetSmsChannelResponse"); };
})(GetSmsChannelResponse || (GetSmsChannelResponse = {}));
export var GetSmsTemplateRequest;
(function (GetSmsTemplateRequest) {
    GetSmsTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSmsTemplateRequest.isa = function (o) { return __isa(o, "GetSmsTemplateRequest"); };
})(GetSmsTemplateRequest || (GetSmsTemplateRequest = {}));
export var GetSmsTemplateResponse;
(function (GetSmsTemplateResponse) {
    GetSmsTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetSmsTemplateResponse.isa = function (o) { return __isa(o, "GetSmsTemplateResponse"); };
})(GetSmsTemplateResponse || (GetSmsTemplateResponse = {}));
export var GetUserEndpointsRequest;
(function (GetUserEndpointsRequest) {
    GetUserEndpointsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetUserEndpointsRequest.isa = function (o) { return __isa(o, "GetUserEndpointsRequest"); };
})(GetUserEndpointsRequest || (GetUserEndpointsRequest = {}));
export var GetUserEndpointsResponse;
(function (GetUserEndpointsResponse) {
    GetUserEndpointsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetUserEndpointsResponse.isa = function (o) { return __isa(o, "GetUserEndpointsResponse"); };
})(GetUserEndpointsResponse || (GetUserEndpointsResponse = {}));
export var GetVoiceChannelRequest;
(function (GetVoiceChannelRequest) {
    GetVoiceChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetVoiceChannelRequest.isa = function (o) { return __isa(o, "GetVoiceChannelRequest"); };
})(GetVoiceChannelRequest || (GetVoiceChannelRequest = {}));
export var GetVoiceChannelResponse;
(function (GetVoiceChannelResponse) {
    GetVoiceChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetVoiceChannelResponse.isa = function (o) { return __isa(o, "GetVoiceChannelResponse"); };
})(GetVoiceChannelResponse || (GetVoiceChannelResponse = {}));
export var GetVoiceTemplateRequest;
(function (GetVoiceTemplateRequest) {
    GetVoiceTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetVoiceTemplateRequest.isa = function (o) { return __isa(o, "GetVoiceTemplateRequest"); };
})(GetVoiceTemplateRequest || (GetVoiceTemplateRequest = {}));
export var GetVoiceTemplateResponse;
(function (GetVoiceTemplateResponse) {
    GetVoiceTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GetVoiceTemplateResponse.isa = function (o) { return __isa(o, "GetVoiceTemplateResponse"); };
})(GetVoiceTemplateResponse || (GetVoiceTemplateResponse = {}));
export var GPSCoordinates;
(function (GPSCoordinates) {
    GPSCoordinates.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GPSCoordinates.isa = function (o) { return __isa(o, "GPSCoordinates"); };
})(GPSCoordinates || (GPSCoordinates = {}));
export var GPSPointDimension;
(function (GPSPointDimension) {
    GPSPointDimension.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    GPSPointDimension.isa = function (o) { return __isa(o, "GPSPointDimension"); };
})(GPSPointDimension || (GPSPointDimension = {}));
export var HoldoutActivity;
(function (HoldoutActivity) {
    HoldoutActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    HoldoutActivity.isa = function (o) { return __isa(o, "HoldoutActivity"); };
})(HoldoutActivity || (HoldoutActivity = {}));
export var ImportJobRequest;
(function (ImportJobRequest) {
    ImportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ImportJobRequest.isa = function (o) { return __isa(o, "ImportJobRequest"); };
})(ImportJobRequest || (ImportJobRequest = {}));
export var ImportJobResource;
(function (ImportJobResource) {
    ImportJobResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ImportJobResource.isa = function (o) { return __isa(o, "ImportJobResource"); };
})(ImportJobResource || (ImportJobResource = {}));
export var ImportJobResponse;
(function (ImportJobResponse) {
    ImportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ImportJobResponse.isa = function (o) { return __isa(o, "ImportJobResponse"); };
})(ImportJobResponse || (ImportJobResponse = {}));
export var ImportJobsResponse;
(function (ImportJobsResponse) {
    ImportJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ImportJobsResponse.isa = function (o) { return __isa(o, "ImportJobsResponse"); };
})(ImportJobsResponse || (ImportJobsResponse = {}));
export var Include;
(function (Include) {
    Include["ALL"] = "ALL";
    Include["ANY"] = "ANY";
    Include["NONE"] = "NONE";
})(Include || (Include = {}));
export var InternalServerErrorException;
(function (InternalServerErrorException) {
    InternalServerErrorException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    InternalServerErrorException.isa = function (o) { return __isa(o, "InternalServerErrorException"); };
})(InternalServerErrorException || (InternalServerErrorException = {}));
export var ItemResponse;
(function (ItemResponse) {
    ItemResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ItemResponse.isa = function (o) { return __isa(o, "ItemResponse"); };
})(ItemResponse || (ItemResponse = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["COMPLETED"] = "COMPLETED";
    JobStatus["COMPLETING"] = "COMPLETING";
    JobStatus["CREATED"] = "CREATED";
    JobStatus["FAILED"] = "FAILED";
    JobStatus["FAILING"] = "FAILING";
    JobStatus["INITIALIZING"] = "INITIALIZING";
    JobStatus["PENDING_JOB"] = "PENDING_JOB";
    JobStatus["PREPARING_FOR_INITIALIZATION"] = "PREPARING_FOR_INITIALIZATION";
    JobStatus["PROCESSING"] = "PROCESSING";
})(JobStatus || (JobStatus = {}));
export var JourneyCustomMessage;
(function (JourneyCustomMessage) {
    JourneyCustomMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneyCustomMessage.isa = function (o) { return __isa(o, "JourneyCustomMessage"); };
})(JourneyCustomMessage || (JourneyCustomMessage = {}));
export var JourneyDateRangeKpiResponse;
(function (JourneyDateRangeKpiResponse) {
    JourneyDateRangeKpiResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneyDateRangeKpiResponse.isa = function (o) { return __isa(o, "JourneyDateRangeKpiResponse"); };
})(JourneyDateRangeKpiResponse || (JourneyDateRangeKpiResponse = {}));
export var JourneyEmailMessage;
(function (JourneyEmailMessage) {
    JourneyEmailMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneyEmailMessage.isa = function (o) { return __isa(o, "JourneyEmailMessage"); };
})(JourneyEmailMessage || (JourneyEmailMessage = {}));
export var JourneyExecutionActivityMetricsResponse;
(function (JourneyExecutionActivityMetricsResponse) {
    JourneyExecutionActivityMetricsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneyExecutionActivityMetricsResponse.isa = function (o) {
        return __isa(o, "JourneyExecutionActivityMetricsResponse");
    };
})(JourneyExecutionActivityMetricsResponse || (JourneyExecutionActivityMetricsResponse = {}));
export var JourneyExecutionMetricsResponse;
(function (JourneyExecutionMetricsResponse) {
    JourneyExecutionMetricsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneyExecutionMetricsResponse.isa = function (o) { return __isa(o, "JourneyExecutionMetricsResponse"); };
})(JourneyExecutionMetricsResponse || (JourneyExecutionMetricsResponse = {}));
export var JourneyLimits;
(function (JourneyLimits) {
    JourneyLimits.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneyLimits.isa = function (o) { return __isa(o, "JourneyLimits"); };
})(JourneyLimits || (JourneyLimits = {}));
export var JourneyPushMessage;
(function (JourneyPushMessage) {
    JourneyPushMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneyPushMessage.isa = function (o) { return __isa(o, "JourneyPushMessage"); };
})(JourneyPushMessage || (JourneyPushMessage = {}));
export var JourneyResponse;
(function (JourneyResponse) {
    JourneyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneyResponse.isa = function (o) { return __isa(o, "JourneyResponse"); };
})(JourneyResponse || (JourneyResponse = {}));
export var JourneySchedule;
(function (JourneySchedule) {
    JourneySchedule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneySchedule.isa = function (o) { return __isa(o, "JourneySchedule"); };
})(JourneySchedule || (JourneySchedule = {}));
export var JourneySMSMessage;
(function (JourneySMSMessage) {
    JourneySMSMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneySMSMessage.isa = function (o) { return __isa(o, "JourneySMSMessage"); };
})(JourneySMSMessage || (JourneySMSMessage = {}));
export var JourneysResponse;
(function (JourneysResponse) {
    JourneysResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneysResponse.isa = function (o) { return __isa(o, "JourneysResponse"); };
})(JourneysResponse || (JourneysResponse = {}));
export var JourneyStateRequest;
(function (JourneyStateRequest) {
    JourneyStateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    JourneyStateRequest.isa = function (o) { return __isa(o, "JourneyStateRequest"); };
})(JourneyStateRequest || (JourneyStateRequest = {}));
export var ListJourneysRequest;
(function (ListJourneysRequest) {
    ListJourneysRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListJourneysRequest.isa = function (o) { return __isa(o, "ListJourneysRequest"); };
})(ListJourneysRequest || (ListJourneysRequest = {}));
export var ListJourneysResponse;
(function (ListJourneysResponse) {
    ListJourneysResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListJourneysResponse.isa = function (o) { return __isa(o, "ListJourneysResponse"); };
})(ListJourneysResponse || (ListJourneysResponse = {}));
export var ListRecommenderConfigurationsResponse;
(function (ListRecommenderConfigurationsResponse) {
    ListRecommenderConfigurationsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListRecommenderConfigurationsResponse.isa = function (o) {
        return __isa(o, "ListRecommenderConfigurationsResponse");
    };
})(ListRecommenderConfigurationsResponse || (ListRecommenderConfigurationsResponse = {}));
export var ListTagsForResourceRequest;
(function (ListTagsForResourceRequest) {
    ListTagsForResourceRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTagsForResourceRequest.isa = function (o) { return __isa(o, "ListTagsForResourceRequest"); };
})(ListTagsForResourceRequest || (ListTagsForResourceRequest = {}));
export var ListTagsForResourceResponse;
(function (ListTagsForResourceResponse) {
    ListTagsForResourceResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTagsForResourceResponse.isa = function (o) { return __isa(o, "ListTagsForResourceResponse"); };
})(ListTagsForResourceResponse || (ListTagsForResourceResponse = {}));
export var ListTemplatesRequest;
(function (ListTemplatesRequest) {
    ListTemplatesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTemplatesRequest.isa = function (o) { return __isa(o, "ListTemplatesRequest"); };
})(ListTemplatesRequest || (ListTemplatesRequest = {}));
export var ListTemplatesResponse;
(function (ListTemplatesResponse) {
    ListTemplatesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTemplatesResponse.isa = function (o) { return __isa(o, "ListTemplatesResponse"); };
})(ListTemplatesResponse || (ListTemplatesResponse = {}));
export var ListTemplateVersionsRequest;
(function (ListTemplateVersionsRequest) {
    ListTemplateVersionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTemplateVersionsRequest.isa = function (o) { return __isa(o, "ListTemplateVersionsRequest"); };
})(ListTemplateVersionsRequest || (ListTemplateVersionsRequest = {}));
export var ListTemplateVersionsResponse;
(function (ListTemplateVersionsResponse) {
    ListTemplateVersionsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ListTemplateVersionsResponse.isa = function (o) { return __isa(o, "ListTemplateVersionsResponse"); };
})(ListTemplateVersionsResponse || (ListTemplateVersionsResponse = {}));
export var Message;
(function (Message) {
    Message.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Message.isa = function (o) { return __isa(o, "Message"); };
})(Message || (Message = {}));
export var MessageBody;
(function (MessageBody) {
    MessageBody.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MessageBody.isa = function (o) { return __isa(o, "MessageBody"); };
})(MessageBody || (MessageBody = {}));
export var MessageConfiguration;
(function (MessageConfiguration) {
    MessageConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MessageConfiguration.isa = function (o) { return __isa(o, "MessageConfiguration"); };
})(MessageConfiguration || (MessageConfiguration = {}));
export var MessageRequest;
(function (MessageRequest) {
    MessageRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MessageRequest.isa = function (o) { return __isa(o, "MessageRequest"); };
})(MessageRequest || (MessageRequest = {}));
export var MessageResponse;
(function (MessageResponse) {
    MessageResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MessageResponse.isa = function (o) { return __isa(o, "MessageResponse"); };
})(MessageResponse || (MessageResponse = {}));
export var MessageResult;
(function (MessageResult) {
    MessageResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MessageResult.isa = function (o) { return __isa(o, "MessageResult"); };
})(MessageResult || (MessageResult = {}));
export var MessageType;
(function (MessageType) {
    MessageType["PROMOTIONAL"] = "PROMOTIONAL";
    MessageType["TRANSACTIONAL"] = "TRANSACTIONAL";
})(MessageType || (MessageType = {}));
export var MethodNotAllowedException;
(function (MethodNotAllowedException) {
    MethodNotAllowedException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MethodNotAllowedException.isa = function (o) { return __isa(o, "MethodNotAllowedException"); };
})(MethodNotAllowedException || (MethodNotAllowedException = {}));
export var MetricDimension;
(function (MetricDimension) {
    MetricDimension.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MetricDimension.isa = function (o) { return __isa(o, "MetricDimension"); };
})(MetricDimension || (MetricDimension = {}));
export var Mode;
(function (Mode) {
    Mode["DELIVERY"] = "DELIVERY";
    Mode["FILTER"] = "FILTER";
})(Mode || (Mode = {}));
export var MultiConditionalBranch;
(function (MultiConditionalBranch) {
    MultiConditionalBranch.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MultiConditionalBranch.isa = function (o) { return __isa(o, "MultiConditionalBranch"); };
})(MultiConditionalBranch || (MultiConditionalBranch = {}));
export var MultiConditionalSplitActivity;
(function (MultiConditionalSplitActivity) {
    MultiConditionalSplitActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    MultiConditionalSplitActivity.isa = function (o) { return __isa(o, "MultiConditionalSplitActivity"); };
})(MultiConditionalSplitActivity || (MultiConditionalSplitActivity = {}));
export var NotFoundException;
(function (NotFoundException) {
    NotFoundException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NotFoundException.isa = function (o) { return __isa(o, "NotFoundException"); };
})(NotFoundException || (NotFoundException = {}));
export var NumberValidateRequest;
(function (NumberValidateRequest) {
    NumberValidateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NumberValidateRequest.isa = function (o) { return __isa(o, "NumberValidateRequest"); };
})(NumberValidateRequest || (NumberValidateRequest = {}));
export var NumberValidateResponse;
(function (NumberValidateResponse) {
    NumberValidateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    NumberValidateResponse.isa = function (o) { return __isa(o, "NumberValidateResponse"); };
})(NumberValidateResponse || (NumberValidateResponse = {}));
export var Operator;
(function (Operator) {
    Operator["ALL"] = "ALL";
    Operator["ANY"] = "ANY";
})(Operator || (Operator = {}));
export var PayloadTooLargeException;
(function (PayloadTooLargeException) {
    PayloadTooLargeException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PayloadTooLargeException.isa = function (o) { return __isa(o, "PayloadTooLargeException"); };
})(PayloadTooLargeException || (PayloadTooLargeException = {}));
export var PhoneNumberValidateRequest;
(function (PhoneNumberValidateRequest) {
    PhoneNumberValidateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PhoneNumberValidateRequest.isa = function (o) { return __isa(o, "PhoneNumberValidateRequest"); };
})(PhoneNumberValidateRequest || (PhoneNumberValidateRequest = {}));
export var PhoneNumberValidateResponse;
(function (PhoneNumberValidateResponse) {
    PhoneNumberValidateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PhoneNumberValidateResponse.isa = function (o) { return __isa(o, "PhoneNumberValidateResponse"); };
})(PhoneNumberValidateResponse || (PhoneNumberValidateResponse = {}));
export var PublicEndpoint;
(function (PublicEndpoint) {
    PublicEndpoint.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PublicEndpoint.isa = function (o) { return __isa(o, "PublicEndpoint"); };
})(PublicEndpoint || (PublicEndpoint = {}));
export var PushMessageActivity;
(function (PushMessageActivity) {
    PushMessageActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PushMessageActivity.isa = function (o) { return __isa(o, "PushMessageActivity"); };
})(PushMessageActivity || (PushMessageActivity = {}));
export var PushNotificationTemplateRequest;
(function (PushNotificationTemplateRequest) {
    PushNotificationTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PushNotificationTemplateRequest.isa = function (o) { return __isa(o, "PushNotificationTemplateRequest"); };
})(PushNotificationTemplateRequest || (PushNotificationTemplateRequest = {}));
export var PushNotificationTemplateResponse;
(function (PushNotificationTemplateResponse) {
    PushNotificationTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PushNotificationTemplateResponse.isa = function (o) { return __isa(o, "PushNotificationTemplateResponse"); };
})(PushNotificationTemplateResponse || (PushNotificationTemplateResponse = {}));
export var PutEventsRequest;
(function (PutEventsRequest) {
    PutEventsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutEventsRequest.isa = function (o) { return __isa(o, "PutEventsRequest"); };
})(PutEventsRequest || (PutEventsRequest = {}));
export var PutEventsResponse;
(function (PutEventsResponse) {
    PutEventsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutEventsResponse.isa = function (o) { return __isa(o, "PutEventsResponse"); };
})(PutEventsResponse || (PutEventsResponse = {}));
export var PutEventStreamRequest;
(function (PutEventStreamRequest) {
    PutEventStreamRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutEventStreamRequest.isa = function (o) { return __isa(o, "PutEventStreamRequest"); };
})(PutEventStreamRequest || (PutEventStreamRequest = {}));
export var PutEventStreamResponse;
(function (PutEventStreamResponse) {
    PutEventStreamResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    PutEventStreamResponse.isa = function (o) { return __isa(o, "PutEventStreamResponse"); };
})(PutEventStreamResponse || (PutEventStreamResponse = {}));
export var QuietTime;
(function (QuietTime) {
    QuietTime.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    QuietTime.isa = function (o) { return __isa(o, "QuietTime"); };
})(QuietTime || (QuietTime = {}));
export var RandomSplitActivity;
(function (RandomSplitActivity) {
    RandomSplitActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RandomSplitActivity.isa = function (o) { return __isa(o, "RandomSplitActivity"); };
})(RandomSplitActivity || (RandomSplitActivity = {}));
export var RandomSplitEntry;
(function (RandomSplitEntry) {
    RandomSplitEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RandomSplitEntry.isa = function (o) { return __isa(o, "RandomSplitEntry"); };
})(RandomSplitEntry || (RandomSplitEntry = {}));
export var RawEmail;
(function (RawEmail) {
    RawEmail.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RawEmail.isa = function (o) { return __isa(o, "RawEmail"); };
})(RawEmail || (RawEmail = {}));
export var RecencyDimension;
(function (RecencyDimension) {
    RecencyDimension.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RecencyDimension.isa = function (o) { return __isa(o, "RecencyDimension"); };
})(RecencyDimension || (RecencyDimension = {}));
export var RecencyType;
(function (RecencyType) {
    RecencyType["ACTIVE"] = "ACTIVE";
    RecencyType["INACTIVE"] = "INACTIVE";
})(RecencyType || (RecencyType = {}));
export var RecommenderConfigurationResponse;
(function (RecommenderConfigurationResponse) {
    RecommenderConfigurationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RecommenderConfigurationResponse.isa = function (o) { return __isa(o, "RecommenderConfigurationResponse"); };
})(RecommenderConfigurationResponse || (RecommenderConfigurationResponse = {}));
export var RemoveAttributesRequest;
(function (RemoveAttributesRequest) {
    RemoveAttributesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RemoveAttributesRequest.isa = function (o) { return __isa(o, "RemoveAttributesRequest"); };
})(RemoveAttributesRequest || (RemoveAttributesRequest = {}));
export var RemoveAttributesResponse;
(function (RemoveAttributesResponse) {
    RemoveAttributesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    RemoveAttributesResponse.isa = function (o) { return __isa(o, "RemoveAttributesResponse"); };
})(RemoveAttributesResponse || (RemoveAttributesResponse = {}));
export var ResultRow;
(function (ResultRow) {
    ResultRow.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ResultRow.isa = function (o) { return __isa(o, "ResultRow"); };
})(ResultRow || (ResultRow = {}));
export var ResultRowValue;
(function (ResultRowValue) {
    ResultRowValue.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    ResultRowValue.isa = function (o) { return __isa(o, "ResultRowValue"); };
})(ResultRowValue || (ResultRowValue = {}));
export var Schedule;
(function (Schedule) {
    Schedule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Schedule.isa = function (o) { return __isa(o, "Schedule"); };
})(Schedule || (Schedule = {}));
export var SegmentBehaviors;
(function (SegmentBehaviors) {
    SegmentBehaviors.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentBehaviors.isa = function (o) { return __isa(o, "SegmentBehaviors"); };
})(SegmentBehaviors || (SegmentBehaviors = {}));
export var SegmentCondition;
(function (SegmentCondition) {
    SegmentCondition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentCondition.isa = function (o) { return __isa(o, "SegmentCondition"); };
})(SegmentCondition || (SegmentCondition = {}));
export var SegmentDemographics;
(function (SegmentDemographics) {
    SegmentDemographics.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentDemographics.isa = function (o) { return __isa(o, "SegmentDemographics"); };
})(SegmentDemographics || (SegmentDemographics = {}));
export var SegmentDimensions;
(function (SegmentDimensions) {
    SegmentDimensions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentDimensions.isa = function (o) { return __isa(o, "SegmentDimensions"); };
})(SegmentDimensions || (SegmentDimensions = {}));
export var SegmentGroup;
(function (SegmentGroup) {
    SegmentGroup.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentGroup.isa = function (o) { return __isa(o, "SegmentGroup"); };
})(SegmentGroup || (SegmentGroup = {}));
export var SegmentGroupList;
(function (SegmentGroupList) {
    SegmentGroupList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentGroupList.isa = function (o) { return __isa(o, "SegmentGroupList"); };
})(SegmentGroupList || (SegmentGroupList = {}));
export var SegmentImportResource;
(function (SegmentImportResource) {
    SegmentImportResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentImportResource.isa = function (o) { return __isa(o, "SegmentImportResource"); };
})(SegmentImportResource || (SegmentImportResource = {}));
export var SegmentLocation;
(function (SegmentLocation) {
    SegmentLocation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentLocation.isa = function (o) { return __isa(o, "SegmentLocation"); };
})(SegmentLocation || (SegmentLocation = {}));
export var SegmentReference;
(function (SegmentReference) {
    SegmentReference.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentReference.isa = function (o) { return __isa(o, "SegmentReference"); };
})(SegmentReference || (SegmentReference = {}));
export var SegmentResponse;
(function (SegmentResponse) {
    SegmentResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentResponse.isa = function (o) { return __isa(o, "SegmentResponse"); };
})(SegmentResponse || (SegmentResponse = {}));
export var SegmentsResponse;
(function (SegmentsResponse) {
    SegmentsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SegmentsResponse.isa = function (o) { return __isa(o, "SegmentsResponse"); };
})(SegmentsResponse || (SegmentsResponse = {}));
export var SegmentType;
(function (SegmentType) {
    SegmentType["DIMENSIONAL"] = "DIMENSIONAL";
    SegmentType["IMPORT"] = "IMPORT";
})(SegmentType || (SegmentType = {}));
export var SendMessagesRequest;
(function (SendMessagesRequest) {
    SendMessagesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SendMessagesRequest.isa = function (o) { return __isa(o, "SendMessagesRequest"); };
})(SendMessagesRequest || (SendMessagesRequest = {}));
export var SendMessagesResponse;
(function (SendMessagesResponse) {
    SendMessagesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SendMessagesResponse.isa = function (o) { return __isa(o, "SendMessagesResponse"); };
})(SendMessagesResponse || (SendMessagesResponse = {}));
export var SendUsersMessageRequest;
(function (SendUsersMessageRequest) {
    SendUsersMessageRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SendUsersMessageRequest.isa = function (o) { return __isa(o, "SendUsersMessageRequest"); };
})(SendUsersMessageRequest || (SendUsersMessageRequest = {}));
export var SendUsersMessageResponse;
(function (SendUsersMessageResponse) {
    SendUsersMessageResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SendUsersMessageResponse.isa = function (o) { return __isa(o, "SendUsersMessageResponse"); };
})(SendUsersMessageResponse || (SendUsersMessageResponse = {}));
export var SendUsersMessagesRequest;
(function (SendUsersMessagesRequest) {
    SendUsersMessagesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SendUsersMessagesRequest.isa = function (o) { return __isa(o, "SendUsersMessagesRequest"); };
})(SendUsersMessagesRequest || (SendUsersMessagesRequest = {}));
export var SendUsersMessagesResponse;
(function (SendUsersMessagesResponse) {
    SendUsersMessagesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SendUsersMessagesResponse.isa = function (o) { return __isa(o, "SendUsersMessagesResponse"); };
})(SendUsersMessagesResponse || (SendUsersMessagesResponse = {}));
export var Session;
(function (Session) {
    Session.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Session.isa = function (o) { return __isa(o, "Session"); };
})(Session || (Session = {}));
export var SetDimension;
(function (SetDimension) {
    SetDimension.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SetDimension.isa = function (o) { return __isa(o, "SetDimension"); };
})(SetDimension || (SetDimension = {}));
export var SimpleCondition;
(function (SimpleCondition) {
    SimpleCondition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SimpleCondition.isa = function (o) { return __isa(o, "SimpleCondition"); };
})(SimpleCondition || (SimpleCondition = {}));
export var SimpleEmail;
(function (SimpleEmail) {
    SimpleEmail.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SimpleEmail.isa = function (o) { return __isa(o, "SimpleEmail"); };
})(SimpleEmail || (SimpleEmail = {}));
export var SimpleEmailPart;
(function (SimpleEmailPart) {
    SimpleEmailPart.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SimpleEmailPart.isa = function (o) { return __isa(o, "SimpleEmailPart"); };
})(SimpleEmailPart || (SimpleEmailPart = {}));
export var SMSChannelRequest;
(function (SMSChannelRequest) {
    SMSChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SMSChannelRequest.isa = function (o) { return __isa(o, "SMSChannelRequest"); };
})(SMSChannelRequest || (SMSChannelRequest = {}));
export var SMSChannelResponse;
(function (SMSChannelResponse) {
    SMSChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SMSChannelResponse.isa = function (o) { return __isa(o, "SMSChannelResponse"); };
})(SMSChannelResponse || (SMSChannelResponse = {}));
export var SMSMessage;
(function (SMSMessage) {
    SMSMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SMSMessage.isa = function (o) { return __isa(o, "SMSMessage"); };
})(SMSMessage || (SMSMessage = {}));
export var SMSMessageActivity;
(function (SMSMessageActivity) {
    SMSMessageActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SMSMessageActivity.isa = function (o) { return __isa(o, "SMSMessageActivity"); };
})(SMSMessageActivity || (SMSMessageActivity = {}));
export var SMSTemplateRequest;
(function (SMSTemplateRequest) {
    SMSTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SMSTemplateRequest.isa = function (o) { return __isa(o, "SMSTemplateRequest"); };
})(SMSTemplateRequest || (SMSTemplateRequest = {}));
export var SMSTemplateResponse;
(function (SMSTemplateResponse) {
    SMSTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    SMSTemplateResponse.isa = function (o) { return __isa(o, "SMSTemplateResponse"); };
})(SMSTemplateResponse || (SMSTemplateResponse = {}));
export var SourceType;
(function (SourceType) {
    SourceType["ALL"] = "ALL";
    SourceType["ANY"] = "ANY";
    SourceType["NONE"] = "NONE";
})(SourceType || (SourceType = {}));
export var StartCondition;
(function (StartCondition) {
    StartCondition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    StartCondition.isa = function (o) { return __isa(o, "StartCondition"); };
})(StartCondition || (StartCondition = {}));
export var State;
(function (State) {
    State["ACTIVE"] = "ACTIVE";
    State["CANCELLED"] = "CANCELLED";
    State["CLOSED"] = "CLOSED";
    State["COMPLETED"] = "COMPLETED";
    State["DRAFT"] = "DRAFT";
})(State || (State = {}));
export var TagResourceRequest;
(function (TagResourceRequest) {
    TagResourceRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TagResourceRequest.isa = function (o) { return __isa(o, "TagResourceRequest"); };
})(TagResourceRequest || (TagResourceRequest = {}));
export var TagsModel;
(function (TagsModel) {
    TagsModel.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TagsModel.isa = function (o) { return __isa(o, "TagsModel"); };
})(TagsModel || (TagsModel = {}));
export var Template;
(function (Template) {
    Template.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    Template.isa = function (o) { return __isa(o, "Template"); };
})(Template || (Template = {}));
export var TemplateActiveVersionRequest;
(function (TemplateActiveVersionRequest) {
    TemplateActiveVersionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TemplateActiveVersionRequest.isa = function (o) { return __isa(o, "TemplateActiveVersionRequest"); };
})(TemplateActiveVersionRequest || (TemplateActiveVersionRequest = {}));
export var TemplateConfiguration;
(function (TemplateConfiguration) {
    TemplateConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TemplateConfiguration.isa = function (o) { return __isa(o, "TemplateConfiguration"); };
})(TemplateConfiguration || (TemplateConfiguration = {}));
export var TemplateResponse;
(function (TemplateResponse) {
    TemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TemplateResponse.isa = function (o) { return __isa(o, "TemplateResponse"); };
})(TemplateResponse || (TemplateResponse = {}));
export var TemplatesResponse;
(function (TemplatesResponse) {
    TemplatesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TemplatesResponse.isa = function (o) { return __isa(o, "TemplatesResponse"); };
})(TemplatesResponse || (TemplatesResponse = {}));
export var TemplateType;
(function (TemplateType) {
    TemplateType["EMAIL"] = "EMAIL";
    TemplateType["PUSH"] = "PUSH";
    TemplateType["SMS"] = "SMS";
    TemplateType["VOICE"] = "VOICE";
})(TemplateType || (TemplateType = {}));
export var TemplateVersionResponse;
(function (TemplateVersionResponse) {
    TemplateVersionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TemplateVersionResponse.isa = function (o) { return __isa(o, "TemplateVersionResponse"); };
})(TemplateVersionResponse || (TemplateVersionResponse = {}));
export var TemplateVersionsResponse;
(function (TemplateVersionsResponse) {
    TemplateVersionsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TemplateVersionsResponse.isa = function (o) { return __isa(o, "TemplateVersionsResponse"); };
})(TemplateVersionsResponse || (TemplateVersionsResponse = {}));
export var TooManyRequestsException;
(function (TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TooManyRequestsException.isa = function (o) { return __isa(o, "TooManyRequestsException"); };
})(TooManyRequestsException || (TooManyRequestsException = {}));
export var TreatmentResource;
(function (TreatmentResource) {
    TreatmentResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    TreatmentResource.isa = function (o) { return __isa(o, "TreatmentResource"); };
})(TreatmentResource || (TreatmentResource = {}));
export var Type;
(function (Type) {
    Type["ALL"] = "ALL";
    Type["ANY"] = "ANY";
    Type["NONE"] = "NONE";
})(Type || (Type = {}));
export var UntagResourceRequest;
(function (UntagResourceRequest) {
    UntagResourceRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UntagResourceRequest.isa = function (o) { return __isa(o, "UntagResourceRequest"); };
})(UntagResourceRequest || (UntagResourceRequest = {}));
export var UpdateAdmChannelRequest;
(function (UpdateAdmChannelRequest) {
    UpdateAdmChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateAdmChannelRequest.isa = function (o) { return __isa(o, "UpdateAdmChannelRequest"); };
})(UpdateAdmChannelRequest || (UpdateAdmChannelRequest = {}));
export var UpdateAdmChannelResponse;
(function (UpdateAdmChannelResponse) {
    UpdateAdmChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateAdmChannelResponse.isa = function (o) { return __isa(o, "UpdateAdmChannelResponse"); };
})(UpdateAdmChannelResponse || (UpdateAdmChannelResponse = {}));
export var UpdateApnsChannelRequest;
(function (UpdateApnsChannelRequest) {
    UpdateApnsChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateApnsChannelRequest.isa = function (o) { return __isa(o, "UpdateApnsChannelRequest"); };
})(UpdateApnsChannelRequest || (UpdateApnsChannelRequest = {}));
export var UpdateApnsChannelResponse;
(function (UpdateApnsChannelResponse) {
    UpdateApnsChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateApnsChannelResponse.isa = function (o) { return __isa(o, "UpdateApnsChannelResponse"); };
})(UpdateApnsChannelResponse || (UpdateApnsChannelResponse = {}));
export var UpdateApnsSandboxChannelRequest;
(function (UpdateApnsSandboxChannelRequest) {
    UpdateApnsSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateApnsSandboxChannelRequest.isa = function (o) { return __isa(o, "UpdateApnsSandboxChannelRequest"); };
})(UpdateApnsSandboxChannelRequest || (UpdateApnsSandboxChannelRequest = {}));
export var UpdateApnsSandboxChannelResponse;
(function (UpdateApnsSandboxChannelResponse) {
    UpdateApnsSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateApnsSandboxChannelResponse.isa = function (o) { return __isa(o, "UpdateApnsSandboxChannelResponse"); };
})(UpdateApnsSandboxChannelResponse || (UpdateApnsSandboxChannelResponse = {}));
export var UpdateApnsVoipChannelRequest;
(function (UpdateApnsVoipChannelRequest) {
    UpdateApnsVoipChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateApnsVoipChannelRequest.isa = function (o) { return __isa(o, "UpdateApnsVoipChannelRequest"); };
})(UpdateApnsVoipChannelRequest || (UpdateApnsVoipChannelRequest = {}));
export var UpdateApnsVoipChannelResponse;
(function (UpdateApnsVoipChannelResponse) {
    UpdateApnsVoipChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateApnsVoipChannelResponse.isa = function (o) { return __isa(o, "UpdateApnsVoipChannelResponse"); };
})(UpdateApnsVoipChannelResponse || (UpdateApnsVoipChannelResponse = {}));
export var UpdateApnsVoipSandboxChannelRequest;
(function (UpdateApnsVoipSandboxChannelRequest) {
    UpdateApnsVoipSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateApnsVoipSandboxChannelRequest.isa = function (o) {
        return __isa(o, "UpdateApnsVoipSandboxChannelRequest");
    };
})(UpdateApnsVoipSandboxChannelRequest || (UpdateApnsVoipSandboxChannelRequest = {}));
export var UpdateApnsVoipSandboxChannelResponse;
(function (UpdateApnsVoipSandboxChannelResponse) {
    UpdateApnsVoipSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateApnsVoipSandboxChannelResponse.isa = function (o) {
        return __isa(o, "UpdateApnsVoipSandboxChannelResponse");
    };
})(UpdateApnsVoipSandboxChannelResponse || (UpdateApnsVoipSandboxChannelResponse = {}));
export var UpdateApplicationSettingsRequest;
(function (UpdateApplicationSettingsRequest) {
    UpdateApplicationSettingsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateApplicationSettingsRequest.isa = function (o) { return __isa(o, "UpdateApplicationSettingsRequest"); };
})(UpdateApplicationSettingsRequest || (UpdateApplicationSettingsRequest = {}));
export var UpdateApplicationSettingsResponse;
(function (UpdateApplicationSettingsResponse) {
    UpdateApplicationSettingsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateApplicationSettingsResponse.isa = function (o) { return __isa(o, "UpdateApplicationSettingsResponse"); };
})(UpdateApplicationSettingsResponse || (UpdateApplicationSettingsResponse = {}));
export var UpdateAttributesRequest;
(function (UpdateAttributesRequest) {
    UpdateAttributesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateAttributesRequest.isa = function (o) { return __isa(o, "UpdateAttributesRequest"); };
})(UpdateAttributesRequest || (UpdateAttributesRequest = {}));
export var UpdateBaiduChannelRequest;
(function (UpdateBaiduChannelRequest) {
    UpdateBaiduChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateBaiduChannelRequest.isa = function (o) { return __isa(o, "UpdateBaiduChannelRequest"); };
})(UpdateBaiduChannelRequest || (UpdateBaiduChannelRequest = {}));
export var UpdateBaiduChannelResponse;
(function (UpdateBaiduChannelResponse) {
    UpdateBaiduChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateBaiduChannelResponse.isa = function (o) { return __isa(o, "UpdateBaiduChannelResponse"); };
})(UpdateBaiduChannelResponse || (UpdateBaiduChannelResponse = {}));
export var UpdateCampaignRequest;
(function (UpdateCampaignRequest) {
    UpdateCampaignRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateCampaignRequest.isa = function (o) { return __isa(o, "UpdateCampaignRequest"); };
})(UpdateCampaignRequest || (UpdateCampaignRequest = {}));
export var UpdateCampaignResponse;
(function (UpdateCampaignResponse) {
    UpdateCampaignResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateCampaignResponse.isa = function (o) { return __isa(o, "UpdateCampaignResponse"); };
})(UpdateCampaignResponse || (UpdateCampaignResponse = {}));
export var UpdateEmailChannelRequest;
(function (UpdateEmailChannelRequest) {
    UpdateEmailChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateEmailChannelRequest.isa = function (o) { return __isa(o, "UpdateEmailChannelRequest"); };
})(UpdateEmailChannelRequest || (UpdateEmailChannelRequest = {}));
export var UpdateEmailChannelResponse;
(function (UpdateEmailChannelResponse) {
    UpdateEmailChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateEmailChannelResponse.isa = function (o) { return __isa(o, "UpdateEmailChannelResponse"); };
})(UpdateEmailChannelResponse || (UpdateEmailChannelResponse = {}));
export var UpdateEmailTemplateRequest;
(function (UpdateEmailTemplateRequest) {
    UpdateEmailTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateEmailTemplateRequest.isa = function (o) { return __isa(o, "UpdateEmailTemplateRequest"); };
})(UpdateEmailTemplateRequest || (UpdateEmailTemplateRequest = {}));
export var UpdateEmailTemplateResponse;
(function (UpdateEmailTemplateResponse) {
    UpdateEmailTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateEmailTemplateResponse.isa = function (o) { return __isa(o, "UpdateEmailTemplateResponse"); };
})(UpdateEmailTemplateResponse || (UpdateEmailTemplateResponse = {}));
export var UpdateEndpointRequest;
(function (UpdateEndpointRequest) {
    UpdateEndpointRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateEndpointRequest.isa = function (o) { return __isa(o, "UpdateEndpointRequest"); };
})(UpdateEndpointRequest || (UpdateEndpointRequest = {}));
export var UpdateEndpointResponse;
(function (UpdateEndpointResponse) {
    UpdateEndpointResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateEndpointResponse.isa = function (o) { return __isa(o, "UpdateEndpointResponse"); };
})(UpdateEndpointResponse || (UpdateEndpointResponse = {}));
export var UpdateEndpointsBatchRequest;
(function (UpdateEndpointsBatchRequest) {
    UpdateEndpointsBatchRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateEndpointsBatchRequest.isa = function (o) { return __isa(o, "UpdateEndpointsBatchRequest"); };
})(UpdateEndpointsBatchRequest || (UpdateEndpointsBatchRequest = {}));
export var UpdateEndpointsBatchResponse;
(function (UpdateEndpointsBatchResponse) {
    UpdateEndpointsBatchResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateEndpointsBatchResponse.isa = function (o) { return __isa(o, "UpdateEndpointsBatchResponse"); };
})(UpdateEndpointsBatchResponse || (UpdateEndpointsBatchResponse = {}));
export var UpdateGcmChannelRequest;
(function (UpdateGcmChannelRequest) {
    UpdateGcmChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateGcmChannelRequest.isa = function (o) { return __isa(o, "UpdateGcmChannelRequest"); };
})(UpdateGcmChannelRequest || (UpdateGcmChannelRequest = {}));
export var UpdateGcmChannelResponse;
(function (UpdateGcmChannelResponse) {
    UpdateGcmChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateGcmChannelResponse.isa = function (o) { return __isa(o, "UpdateGcmChannelResponse"); };
})(UpdateGcmChannelResponse || (UpdateGcmChannelResponse = {}));
export var UpdateJourneyRequest;
(function (UpdateJourneyRequest) {
    UpdateJourneyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateJourneyRequest.isa = function (o) { return __isa(o, "UpdateJourneyRequest"); };
})(UpdateJourneyRequest || (UpdateJourneyRequest = {}));
export var UpdateJourneyResponse;
(function (UpdateJourneyResponse) {
    UpdateJourneyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateJourneyResponse.isa = function (o) { return __isa(o, "UpdateJourneyResponse"); };
})(UpdateJourneyResponse || (UpdateJourneyResponse = {}));
export var UpdateJourneyStateRequest;
(function (UpdateJourneyStateRequest) {
    UpdateJourneyStateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateJourneyStateRequest.isa = function (o) { return __isa(o, "UpdateJourneyStateRequest"); };
})(UpdateJourneyStateRequest || (UpdateJourneyStateRequest = {}));
export var UpdateJourneyStateResponse;
(function (UpdateJourneyStateResponse) {
    UpdateJourneyStateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateJourneyStateResponse.isa = function (o) { return __isa(o, "UpdateJourneyStateResponse"); };
})(UpdateJourneyStateResponse || (UpdateJourneyStateResponse = {}));
export var UpdatePushTemplateRequest;
(function (UpdatePushTemplateRequest) {
    UpdatePushTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdatePushTemplateRequest.isa = function (o) { return __isa(o, "UpdatePushTemplateRequest"); };
})(UpdatePushTemplateRequest || (UpdatePushTemplateRequest = {}));
export var UpdatePushTemplateResponse;
(function (UpdatePushTemplateResponse) {
    UpdatePushTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdatePushTemplateResponse.isa = function (o) { return __isa(o, "UpdatePushTemplateResponse"); };
})(UpdatePushTemplateResponse || (UpdatePushTemplateResponse = {}));
export var UpdateRecommenderConfigurationRequest;
(function (UpdateRecommenderConfigurationRequest) {
    UpdateRecommenderConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateRecommenderConfigurationRequest.isa = function (o) {
        return __isa(o, "UpdateRecommenderConfigurationRequest");
    };
})(UpdateRecommenderConfigurationRequest || (UpdateRecommenderConfigurationRequest = {}));
export var UpdateRecommenderConfigurationResponse;
(function (UpdateRecommenderConfigurationResponse) {
    UpdateRecommenderConfigurationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateRecommenderConfigurationResponse.isa = function (o) {
        return __isa(o, "UpdateRecommenderConfigurationResponse");
    };
})(UpdateRecommenderConfigurationResponse || (UpdateRecommenderConfigurationResponse = {}));
export var UpdateRecommenderConfigurationShape;
(function (UpdateRecommenderConfigurationShape) {
    UpdateRecommenderConfigurationShape.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateRecommenderConfigurationShape.isa = function (o) {
        return __isa(o, "UpdateRecommenderConfigurationShape");
    };
})(UpdateRecommenderConfigurationShape || (UpdateRecommenderConfigurationShape = {}));
export var UpdateSegmentRequest;
(function (UpdateSegmentRequest) {
    UpdateSegmentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateSegmentRequest.isa = function (o) { return __isa(o, "UpdateSegmentRequest"); };
})(UpdateSegmentRequest || (UpdateSegmentRequest = {}));
export var UpdateSegmentResponse;
(function (UpdateSegmentResponse) {
    UpdateSegmentResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateSegmentResponse.isa = function (o) { return __isa(o, "UpdateSegmentResponse"); };
})(UpdateSegmentResponse || (UpdateSegmentResponse = {}));
export var UpdateSmsChannelRequest;
(function (UpdateSmsChannelRequest) {
    UpdateSmsChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateSmsChannelRequest.isa = function (o) { return __isa(o, "UpdateSmsChannelRequest"); };
})(UpdateSmsChannelRequest || (UpdateSmsChannelRequest = {}));
export var UpdateSmsChannelResponse;
(function (UpdateSmsChannelResponse) {
    UpdateSmsChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateSmsChannelResponse.isa = function (o) { return __isa(o, "UpdateSmsChannelResponse"); };
})(UpdateSmsChannelResponse || (UpdateSmsChannelResponse = {}));
export var UpdateSmsTemplateRequest;
(function (UpdateSmsTemplateRequest) {
    UpdateSmsTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateSmsTemplateRequest.isa = function (o) { return __isa(o, "UpdateSmsTemplateRequest"); };
})(UpdateSmsTemplateRequest || (UpdateSmsTemplateRequest = {}));
export var UpdateSmsTemplateResponse;
(function (UpdateSmsTemplateResponse) {
    UpdateSmsTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateSmsTemplateResponse.isa = function (o) { return __isa(o, "UpdateSmsTemplateResponse"); };
})(UpdateSmsTemplateResponse || (UpdateSmsTemplateResponse = {}));
export var UpdateTemplateActiveVersionRequest;
(function (UpdateTemplateActiveVersionRequest) {
    UpdateTemplateActiveVersionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateTemplateActiveVersionRequest.isa = function (o) {
        return __isa(o, "UpdateTemplateActiveVersionRequest");
    };
})(UpdateTemplateActiveVersionRequest || (UpdateTemplateActiveVersionRequest = {}));
export var UpdateTemplateActiveVersionResponse;
(function (UpdateTemplateActiveVersionResponse) {
    UpdateTemplateActiveVersionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateTemplateActiveVersionResponse.isa = function (o) {
        return __isa(o, "UpdateTemplateActiveVersionResponse");
    };
})(UpdateTemplateActiveVersionResponse || (UpdateTemplateActiveVersionResponse = {}));
export var UpdateVoiceChannelRequest;
(function (UpdateVoiceChannelRequest) {
    UpdateVoiceChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateVoiceChannelRequest.isa = function (o) { return __isa(o, "UpdateVoiceChannelRequest"); };
})(UpdateVoiceChannelRequest || (UpdateVoiceChannelRequest = {}));
export var UpdateVoiceChannelResponse;
(function (UpdateVoiceChannelResponse) {
    UpdateVoiceChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateVoiceChannelResponse.isa = function (o) { return __isa(o, "UpdateVoiceChannelResponse"); };
})(UpdateVoiceChannelResponse || (UpdateVoiceChannelResponse = {}));
export var UpdateVoiceTemplateRequest;
(function (UpdateVoiceTemplateRequest) {
    UpdateVoiceTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateVoiceTemplateRequest.isa = function (o) { return __isa(o, "UpdateVoiceTemplateRequest"); };
})(UpdateVoiceTemplateRequest || (UpdateVoiceTemplateRequest = {}));
export var UpdateVoiceTemplateResponse;
(function (UpdateVoiceTemplateResponse) {
    UpdateVoiceTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    UpdateVoiceTemplateResponse.isa = function (o) { return __isa(o, "UpdateVoiceTemplateResponse"); };
})(UpdateVoiceTemplateResponse || (UpdateVoiceTemplateResponse = {}));
export var VoiceChannelRequest;
(function (VoiceChannelRequest) {
    VoiceChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    VoiceChannelRequest.isa = function (o) { return __isa(o, "VoiceChannelRequest"); };
})(VoiceChannelRequest || (VoiceChannelRequest = {}));
export var VoiceChannelResponse;
(function (VoiceChannelResponse) {
    VoiceChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    VoiceChannelResponse.isa = function (o) { return __isa(o, "VoiceChannelResponse"); };
})(VoiceChannelResponse || (VoiceChannelResponse = {}));
export var VoiceMessage;
(function (VoiceMessage) {
    VoiceMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    VoiceMessage.isa = function (o) { return __isa(o, "VoiceMessage"); };
})(VoiceMessage || (VoiceMessage = {}));
export var VoiceTemplateRequest;
(function (VoiceTemplateRequest) {
    VoiceTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    VoiceTemplateRequest.isa = function (o) { return __isa(o, "VoiceTemplateRequest"); };
})(VoiceTemplateRequest || (VoiceTemplateRequest = {}));
export var VoiceTemplateResponse;
(function (VoiceTemplateResponse) {
    VoiceTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    VoiceTemplateResponse.isa = function (o) { return __isa(o, "VoiceTemplateResponse"); };
})(VoiceTemplateResponse || (VoiceTemplateResponse = {}));
export var WaitActivity;
(function (WaitActivity) {
    WaitActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    WaitActivity.isa = function (o) { return __isa(o, "WaitActivity"); };
})(WaitActivity || (WaitActivity = {}));
export var WaitTime;
(function (WaitTime) {
    WaitTime.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    WaitTime.isa = function (o) { return __isa(o, "WaitTime"); };
})(WaitTime || (WaitTime = {}));
export var WriteApplicationSettingsRequest;
(function (WriteApplicationSettingsRequest) {
    WriteApplicationSettingsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    WriteApplicationSettingsRequest.isa = function (o) { return __isa(o, "WriteApplicationSettingsRequest"); };
})(WriteApplicationSettingsRequest || (WriteApplicationSettingsRequest = {}));
export var WriteCampaignRequest;
(function (WriteCampaignRequest) {
    WriteCampaignRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    WriteCampaignRequest.isa = function (o) { return __isa(o, "WriteCampaignRequest"); };
})(WriteCampaignRequest || (WriteCampaignRequest = {}));
export var WriteEventStream;
(function (WriteEventStream) {
    WriteEventStream.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    WriteEventStream.isa = function (o) { return __isa(o, "WriteEventStream"); };
})(WriteEventStream || (WriteEventStream = {}));
export var WriteJourneyRequest;
(function (WriteJourneyRequest) {
    WriteJourneyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    WriteJourneyRequest.isa = function (o) { return __isa(o, "WriteJourneyRequest"); };
})(WriteJourneyRequest || (WriteJourneyRequest = {}));
export var WriteSegmentRequest;
(function (WriteSegmentRequest) {
    WriteSegmentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    WriteSegmentRequest.isa = function (o) { return __isa(o, "WriteSegmentRequest"); };
})(WriteSegmentRequest || (WriteSegmentRequest = {}));
export var WriteTreatmentResource;
(function (WriteTreatmentResource) {
    WriteTreatmentResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
    WriteTreatmentResource.isa = function (o) { return __isa(o, "WriteTreatmentResource"); };
})(WriteTreatmentResource || (WriteTreatmentResource = {}));
//# sourceMappingURL=index.js.map